import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";

i18n.use(LanguageDetector).init({
	// we init with resources
	resources: {
		th: {
			translations: {
				"Available on": "ดาวน์โหลดแอปพลิเคชัน",
				learn: "สอบถามข้อมูลเพิ่มเติม",
				testdemo: "ขอทดลองใช้ระบบ",
				btnheader: "สมัครสมาชิก HRTable ด้วยรหัสโปรโมชัน",
				"To get started, edit <1>src/App.js</1> and save to reload.":
					"Starte in dem du, <1>src/App.js</1> editierst und speicherst.",
				"Welcome to React": "Willkommen bei React und react-i18next",
				Title: "Welcome to {param}",
				moneytable: "MoneyTable",
				hrtable: "HRTable",
				contactus: "ติดต่อเรา",
				hero1: "แพลตฟอร์มอันชาญฉลาด",
				"hero1.5": "สำหรับการทำงานที่ทันสมัย",
				hero2:
					"จัดการกับปัญหาทางการเงินของพนักงานด้วยระบบสวัสดิการของเรา เพื่อให้พนักงานของคุณได้ทุ่มเทกับงานที่เขารักมากยิ่งขึ้น",
				hero3:
					"ระบบสวัสดิการของเราจะจัดการกับปัญหาทางการเงินของพนักงาน ซึ่งช่วยให้พวกเขาได้ทุ่มเทกับงานที่เขารักมากยิ่งขึ้น",
				hero_product: "ผลิตภัณฑ์ของเรา",
				"newupdate-title": "ข่าวสารวันนี้",
				"newupdate-title-all": "อ่านต่อ",
				"ourproduct-title": "แพลตฟอร์มของเรา",
				"SOLUTIONS THAT WILL SUPER CHARGE YOUR COMPANY":
					"ทางออกที่จะช่วยพัฒนาธุรกิจของคุณ",
				MONEYTABLE: "MONEYTABLE",
				"A Simple, Fast and Reliable Employee Benefit":
					"ระบบสวัสดิการพนักงานที่ง่าย รวดเร็ว และเชื่อถือได้",
				detail1:
					"MoneyTable ช่วยอำนวยความสะดวกด้านการเงินของพนักงานของคุณ ด้วยระบบสวัสดิการฟรี และมีบริการให้พนักงานได้กู้ยืมเงินจากช่องทางทางการเงินที่เชื่อถือได้ ด้วยอัตราดอกเบี้ยที่เป็นธรรม การชำระคืนผ่านระบบอัตโนมัติ นำมาสู่ความสุขในการทำงานของทั้งพนักงานและเจ้าของธุรกิจ",
				HRTABLE: "HRTABLE",
				"A Simple, Fast and Reliable People Operating Platform":
					"ระบบจัดการบุคคลที่ง่าย รวดเร็วและเชื่อถือได้",
				detail2:
					"HRtable คือจัดการบุคคล ระบบของเราจะช่วยลดเวลาในการทำงานเอกสารที่ยุ่งยาก ทำให้คุณสามารถโฟกัสกับการพัฒนาบุคคลากรในบริษัทได้อย่างเต็มที่ เราจะช่วยคุณพัฒนาองค์กรไปอย่างรวดเร็วและง่ายดายกว่าที่เคยเป็นมา",
				detail3:
					"คือสวัสดิการทางการเงินที่ผู้ประกอบการสามารถเสนอแก่พนักงาน เพื่อเพิ่มสภาพคล่องทางการเงินของพนักงาน ด้วยโอกาสที่เข้าถึงง่ายและอัตราเงินกู้ที่เป็นธรรม ซึ่งช่วยเพิ่มประสิทธิภาพในการทำงานของพนักงานของคุณ",
				"Employer’s Value": "ประโยชน์ต่อธุรกิจของคุณ",
				"Employees’s Value": "ประโยชน์ต่อพนักงานของคุณ",
				detail4:
					"ผู้ประกอบการสามารถลดความตึงเครียดทางการเงินของพนักงานของคุณ ด้วย MoneyTable ทำให้พนักงานสามารถเข้าถึงแหล่งเงินกู้ที่มีอัตราดอกเบี้ยต่ำ และ โอกาสอนุมัติสูง ซึ่งจะเพิ่มประสิทธิภาพในการทำงานของพนักงานมากขึ้น",
				detail5:
					"MoneyTable ช่วยเพิ่มโอกาสให้พนักงานเข้าถึงแหล่งเงินกู้ที่มีดอกเบี้ยที่เป็นธรรม และโอกาสอนุมัติสูง ทำให้พนักงานไม่ต้องกังวลกับการถูกปฏิเสธจากธนาคาร ซึ่งช่วยลดความกังวลเกี่ยวกับภาวะทางการเงิน",
				"Easy & Fast Access to loans":
					"เข้าถึงแหล้งเงินกู้ได้ง่ายและรู้ผลรวดเร็ว",
				"Competitive Rates": "อัตราดอกเบี้ยเป็นธรรม",
				"Near 100% Approvals": "โอกาสในการอนุมัติสูง",
				"Reduces Employee Debt Burden":
					"ลดความกังวลเกี่ยวกับภาระหนี้ของพนักงาน",
				"No More Bank Visits": "สามารถส่งคำขอได้โดยไม่ต้องไปธนาคาร",
				"No Rejection*": "ไม่ต้องกังวลกับการถูกปฏิเสธ *",
				"No More High Interest": "อัตราดอกเบี้ยต่ำ",
				"No More Money Worries": "ลดภาระหนี้ของพนักงาน",
				"Reduces Employee Debt Burden1":
					"ระบบบันทึกเวลาเข้าออกงานผ่านแอปพลิเคชัน",
				"No More Bank Visits1": "การส่งคำขอลา",
				"No Rejection*1": "การส่งคำขอเบิก",
				"No More High Interest1": "การขอสลิปเงินเดือน และเอกสารอื่นๆ",
				"No More Money Worries1": "และฟีเจอร์อื่นๆอีกมากมาย",
				"* We have low rejection rates": "* เรามีอัตราการปฏิเสธคำขอต่ำ",
				detail6:
					"HRTable ระบบจัดการบุคคลของเราจะช่วยลดเวลาในการทำงานเอกสาร ซึ่งจะทำให้ฝ่ายบุคคลได้มีเวลากับการพัฒนาทรัพยากรบุคคลในบริษัทมากขึ้น HRTable คือแพลตฟอร์มที่จะช่วยแก้ปัญหาที่ยุ่งยากของฝ่ายบุคคลและเพิ่มประสิทธิภาพในการพัฒนาองค์กรของคุณ",
				detail7:
					"เจ้าของกิจการสามารถบริหารจัดการทรัพยากรบุคคลของคุณได้อย่างครอบคลุมและง่ายดาย ด้วยฟีเจอร์ที่หลากหลายเช่น ระบบคำนวณเงินเดือนและภาษีอัตโนมัติ, ระบบบันทึกเวลาเข้าออกของพนักงานด้วย GPS และเครื่องสแกนลายนิ้วมือ HRTable จะช่วยให้คุณสามารถพัฒนาองค์กรไปได้อีกระดับ",
				detail8:
					"HRTable เป็นแพลตฟอร์มที่มาพร้อมแอปพลิเคชันที่ครบครัน สะดวก ง่ายต่อการใช้งาน เช่น ระบบบันทึกเวลาเข้าออกงานผ่านแอปพลิเคชัน, การส่งคำขอลา คำขอเบิก และการขอเอกสารต่างๆ ด้วยฟีเจอร์เหล่านี้จำให้การติดต่อกับฝ่ายบุคคลเป็นเรื่องง่ายดายและไม่ยุ่งยากอีกต่อไป",
				"Automatic payroll calculation": "ระบบคำนวณเงินเดือนอัตโนมัติ",
				"Automatic calculation": "ระบบคำนวณภาษีอัตโนมัติ",
				"GPS Clock-in and Clock-out":
					"ระบบบันทึกเวลาเข้าออกของพนักงานด้วย GPS และเครื่องแสกนลายนิ้วมือ",
				"Company announcements": "ประกาศบริษัท",
				"And many more features…": "และฟีเจอร์อื่นๆอีกมากมาย",
				"WITH MONEYTABLE PLC, YOU’RE IN GOOD COMPANY":
					"ด้วย MONEYTABLE จะช่วยยกระดับกิจการของคุณไปอีกระดับ",
				detail9:
					"มากกว่า 1,000 บริษัทที่เลือกใช้บริการของเรา เพื่อเพิ่มประสิทธิภาพขององค์กร ติดต่อเราวันนี้และให้ทีมงานของเราช่วยคุณในการใช้ผลิตภัณฑ์ของเรา",
				"More than 100,000 Employee’s Can’t be Wrong":
					"พนักงานมากกว่า 100,000 คนที่ใช้ผลิตภัณฑ์ของเรา",
				detail10:
					"คนที่ลงทะเบียนใช้งานแพลตฟอร์มของเราและผู้ที่ลงทะเบียนเพื่อใช้ระบบเพิ่มขึ้นทุกวัน รับชมวิดิโอเพื่อดูว่าผู้ใช้งานของเรามีความสุขในการใช้งานระบบของเรามากเท่าไหร่",
				detail11:
					"ระบบของเราเป็นระบบ Digital ecosystem ที่การเก็บรักษาข้อมูลบน Cloud ด้วยระบบความปลอดภัยมาตรฐานสูงสุด ซึ่งเป็นระบบเดียวกันกับที่ธนาคารใช้ ทำให้คุณจึงมั่นใจได้ว่าข้อมูลส่วนตัวของคุณจะไม่ศูนย์หาย หรือรั่วไหล",
				"Our Security and Technology is Second to None":
					"ระบบรักษาความปลอดภัยข้อมูล และเทคโนโลยีที่เป็นเลิศ",
				"Private Data Cloud with Bank Approved Security":
					"การเก็บข้อมูลบน Cloud ด้วยระบบมาตรฐานเดียวกันกับธนาคาร",
				"128 Bit Encryption Ensures that Data is Safe":
					"128 Bit Encryption Ensures that Data is Safe",
				"Our EcoSystem Allows Businesses to Manage Their Employees Smoothly 24/7 - 365":
					"มั่นใจว่าข้อมูลส่วนตัวจะปลอดภัยด้วยการเข้ารหัสขนาด 128 บิท",
				detail12:
					"ระบบ Eco-system ของเรามีความพร้อมใช้งานได้ตลอดเวลา สามารถใช้งานได้ทุกวันตลอด 24 ชั่วโมง",
				common1: "ด้วย MONEYTABLE จะช่วยยกระดับกิจการของคุณไปอีกระดับ",
				Wearehelping:
					"มากกว่า 1,000 บริษัทที่เลือกใช้บริการของเรา เพื่อเพิ่มประสิทธิภาพขององค์กร ติดต่อเราวันนี้และให้ทีมงานของเราช่วยคุณในการใช้ผลิตภัณฑ์ของเรา",
				"1000companies": "",
				"employee2-title": "รีวิวจากผู้ใช้งานจริง",
				employee2: "ธุรกิจกว่า 4,000 บริษัท ไว้ใจในระบบของเรา",
				"employee2-1":
					"พนักงานกว่า 100,000 คน ใช้งานโปรแกรมบริหารงานบุคคล และกว่า 10,000 คน ใช้บริการแอปพลิเคชันขอสินเชื่อของเรา และยังคงเพิ่มขึ้นทุกๆวัน รับชมวิดิโอเพื่อดูว่าผู้ใช้งานของเรามีความสุขในการใช้งานระบบของเรามากเท่าไหร่",
				employeelist: "ส่วนหนึ่งของลูกค้าที่ไว้วางใจเรา",
				common2: "",
				common3: "พนักงานมากกว่า 1,000 คนที่ใช้ผลิตภัณฑ์ของเรา",
				common4:
					"คนที่ลงทะเบียนใช้งานแพลตฟอร์มของเราและผู้ที่ลงทะเบียนเพื่อใช้ระบบเพิ่มขึ้นทุกวัน รับชมวิดิโอเพื่อดูว่าผู้ใช้งานของเรามีความสุขในการใช้งานระบบของเรามากเท่าไหร่",
				common5: "ระบบรักษาความปลอดภัยข้อมูล และเทคโนโลยีที่เป็นเลิศ",
				common6:
					"ระบบของเราเป็นระบบ Digital ecosystem ที่การเก็บรักษาข้อมูลบน Cloud ด้วยระบบความปลอดภัยมาตรฐานสูงสุด ซึ่งเป็นระบบเดียวกันกับที่ธนาคารใช้ ทำให้คุณจึงมั่นใจได้ว่าข้อมูลส่วนตัวของคุณจะไม่ศูนย์หาย หรือรั่วไหล",
				common7: "การเก็บข้อมูลบน Cloud ด้วยระบบมาตรฐานเดียวกันกับธนาคาร",
				common8: "มั่นใจว่าข้อมูลส่วนตัวจะปลอดภัยด้วยการเข้ารหัสขนาด 128 บิท",
				common9:
					"ระบบ Eco-system ของเรามีความพร้อมใช้งานได้ตลอดเวลา สามารถใช้งานได้ทุกวันตลอด 24 ชั่วโมง",
				common10: "ติดต่อเราตอนนี้เพื่อทดลองใช้งานระบบของเรา",
				common11:
					"ทีมงานจะให้ข้อมูลเพิ่มเติมเกี่ยวกับผลิตภัณฑ์และช่วยคุณยกระดับธุรกิจไปอีกขั้น",
				common12: "ติดต่อเราผ่านทาง Line",
				common13: "ติดต่อเราเพื่อทดลองใช้งานระบบ",
				MoneyTable: "MoneyTable",
				"A Free Benfit for your Employees":
					"แอปพลิเคชันขอสินเชื่อเพื่อพนักงานของคุณ",
				// "detail1":"ด้วยการลงทะเบียนที่ไม่มีค่าใช้จ่าย ทำให้พนักงานของคุณได้เข้าถึงแหล่งสินเชื่อที่จะช่วยลดความกังวลทางการเงิน แอปพลิเคชันของเราช่วยให้พนักงานของคุณได้เข้าถึงแหล่งสินเชื่อในอัตราดอกเบี้ยที่เป็นธรรม ซึ่งจะช่วยเพิ่มประสิทธิภาพและความสุขในการทำงานของพนักงานมากขึ้น",
				business: "ให้เราเป็นตัวช่วยในการนำพาธุรกิจของคุณไปอีกขั้น",
				"MoneyTable solves your employees money worrys and allows you to focus on your business":
					"ให้ MoneyTable ช่วยลดความกังวลทางการเงิน ซึ่งจะช่วยเพิ่มประสิทธิภาพและความสุขในการทำงานของพนักงานมากขึ้น",
				"Leding the easy way": "ทำเรื่องสินเชื่อเป็นเรื่องง่าย",
				"With MoneyTable as a free benefit for your employees":
					"ด้วย Moneytable สวัสดิการทางการเงินจากแหล่งสินเชื่อที่เชื่อถือได้  คุณสามารถเชื่อมต่อกับแพลตฟอร์มของเรา เพื่อให้พนักงานของคุณสามารถเข้าถึงแหล่งสินเชื่อได้ ซึ่งการชำระเงินคืนจะตัดจากระบบอัตโนมัติ การกรอกข้อมูลเพื่อขอสินเชื่อผ่านทางแอปพลิเคชันของเรา ทำให้การขอสินเชื่อเป็นเรื่องง่ายและรวดเร็วขึ้น",
				"Low Rates, High Approvals":
					"ดอกเบี้ยที่เป็นธรรม และอัตราการอนุมัติสูง",
				"With our loan providers almost all loans can be approved for your employees":
					"ผู้ให้บริการด้านสินเชื่อของเราสามารถอนุมัติคำขอกู้ได้เกือบทั้งหมด ด้วยดอกเบี้ยที่ต่ำ ทำให้พนักงานของคุณได้ข้อเสนอสินเชื่อที่ดีที่สุดในประเทศไทย",
				"YOUR EMPLOYEES’ FINANCIAL WELLBEING MATTERS":
					"ภาระทางการเงินของพนักงานของคุณเป็นเรื่องสำคัญ",
				"Money Worries Result in Lower Employee Productivity":
					"ความกังวลด้านปัญหาทางการเงิน ทำให้ประสิทธิภาพในการทำงานของพนักงานลดลง",
				"Over half of employers worry about their employees":
					"มากกว่าครึ่งนึงของพนักงานในประเทศไทยกำลังประสบกับภาวะปัญหาทางการเงิน จากการสำรวจพบว่า 90% ของพนักงานบอกว่า ความกังวลด้านปัญหาทางการเงินทำให้พวกเขามีประสิทธิภาพในการทำงานลดลง อย่างไรก็ตามทางเจ้าของธุรกิจก็ไม่สามารถมีผู้ช่วยเพื่อแก้ปัญหาส่วนนี้ ด้วย Moneytable จะช่วยลดความกังวลด้านปัญหาทางการเงินของพนักงานของคุณจะหมดไป ช่วยเพิ่มประสิทธิภาพให้กับพวกเขา เพียงแค่ติดต่อเราตอนนี้",
				"Free Platform": "แพลตฟอร์มของเราใช้งานฟรี",
				"MoneyTable wants to enhance the welfare of Employees and help employers":
					"ต้องการที่จะเป็นตัวกลางทำให้เจ้าของธุรกิจ ได้มีช่องทางได้ช่วยเหลือพนักงานในองค์กร ซึ่งแพลตฟอร์มของเรานั้นใช้ง่ายง่ายและไม่มีค่าใช้จ่ายในการสมัคร",
				"Easy Loans": "มีเปอร์เซ็นต์ในการอนุมัติสูง",
				"Our loans see almost 100% approval rates so your employees":
					"คำขอสินเชื่อมีอัตราการอนุมัติเกือบ 100% ซึ่งทำให้พนักงานได้รับเงินที่ต้องการ",
				"Fast Access to Funds": "เข้าถึงแหล่งสินเชื่อได้ง่าย",
				"With our state of the art App and easy user interface":
					"ด้วยขั้นตอนที่ไม่ยุ่งยาก และรูปแบบแอปพลิเคชันที่มีความง่าย ทำให้พนักงานเข้าถึงแหล่งสินเชื่อได้รวดเร็วขึ้น",
				"Affordable Rates": "อัตราดอกเบี้ยที่เป็นธรรม",
				"We have negotiated some of the best rates available in the market":
					"เราสรรหาแหล่งสินเชื่อที่มีอัตราดอกเบี้ยต่ำที่สุด เพื่อสะดวกต่อพนักงานในการจัดสรรการใช้จ่าย",
				"Easy Loan Repayment": "ระบบการจ่ายเงินคืนที่สะดวก",
				"Loans are paid back directly through MoneyTable":
					"ระบบการจ่ายเงินคืนด้วยระบบอัตโนมัติ ซึ่งทำให้การจ่ายเงินคืนเป็นเรื่องง่ายกว่าเดิม",
				"Trusted Sources": "แหล่งสินเชื่อเชื่อถือได้",
				"We partner with leading Banks and Financial institutions":
					"เรามีธนาคารและสถาบันทางการเงินเป็นพันธมิตร ทำให้คุณมั่นใจได้ว่าพนักงานของคุณจะได้รับสินเชื่อที่พวกเขาต้องการ",
				"Increase Productivity": "ช่วยเพิ่มประสิทธิภาพในการทำงาน",
				"With employee money worries gone":
					"เมื่อความกังวลทางการเงินหมดไป ทำให้พนักงานสามารถโฟกัสกับหน้าที่รับผิดชอบของพวกเขาได้มากขึ้น",
				"Customer Service": "มีทีมงานที่คอยดูแลคุณอย่างใกล้ชิด",
				"Our caring customer service team":
					"ทีมงานของเรา พร้อมเสมอที่จะช่วยเหลือคุณเมื่อคุณเกิดปัญหาหรือมีคำถามใดๆ",
				Retain: "ลดการลาออกของพนักงาน",
				"happy employees means less turn over":
					"เมื่อพนักงานของคุณมีความสุขกับการทำงานมากขึ้น นั้นทำให้การลาออกจากงานลดลง",
				Attract: "ดึงดูดให้ผู้คนอยากเข้ามาทำงานในองค์กร",
				"people are more likely to apply to jobs that have more benefits":
					"ผู้คนส่วนใหญ่ต่างต้องการทำงานในองค์กรที่มีสวัสดิการพนักงานที่ดี",
				Motivate: "เพิ่มแรงจูงใจในการทำงาน",
				"employees with more benefits are more likely to have higher motivation":
					"การที่มีสวัสดิการพนักงานที่ดี ทำให้พนักงานมีแรงจูงใจในการทำงานที่เพิ่มมากขึ้น",
				"HR TABLE": "HR TABLE",
				"Easy, Fast & Free":
					"ระบบบริหารงานบุคคล แบบอัตโนมัติ ที่ง่ายและรวดเร็ว",
				"People Operating Platform": "",
				"Manage All Your Branches":
					"ระบบมีแบบฟอร์มเอกสารทุกชนิดที่ใช้กับหน่วยงานรัฐบาล และมีการอัพเดทตลอดเวลา",
				"We provide a state of the art":
					"เราสร้างระบบบริหารงานบุคคล ที่ตอบโจทย์การทำงานสมัยใหม่ และมุ่งพัฒนาองค์กรให้ก้าวสู่ยุคดิจิทัล",
				"MANAGE YOUR TEAM WITH": "เราทำให้เรื่องการบริหารบุคคล",
				"EASE, FOR FREE": "และเอกสารเป็นเรื่องง่ายๆ",
				"With Our Features Your Company":
					"ด้วยฟีเจอร์ของเรา คุณสามารถบริหารจัดการบุคคลของคุณได้อย่างง่ายดายและช่วยให้คุณพัฒนากิจการของคุณไปอีกขั้นในเวลาเดียวกัน",
				"Auto-Calculate Payroll": "ระบบคำนวณการจ่ายเงินเดือนอัตโนมัติ",
				"Never calculate payroll again":
					"ไม่จำเป็นต้องคำนวณเงินเดือนด้วยตนเองอีกต่อไป - HRTable จะช่วยให้การจ่ายเงินเดือนเป็นเรื่องง่ายเพียงปลายนิ้ว",
				"Automatic Payroll Calculation":
					"ระบบคำนวณเงินเดือนอัตโนมัติ ที่นำเอาค่าล่วงเวลา และผลตอบแทนต่างๆ มาคำนวณร่วมด้วย",
				"E-Payslip for Employees":
					"พนักงานสามารถดูรายละเอียดการการจ่ายเงินเดือนได้ผ่าน แอปพลิเคชัน ( E-Payslip )",
				"Taxes Made Easy": "ทำให้การทำภาษีเป็นเรื่องง่าย",
				Financial_Policy: "นโยบายทางการเงิน",
				"Comprehensive Tax Overview":
					"ครอบคลุมเรื่องการจัดการภาษีทั้งหมด - ระบบสามารถทำการคำนวณภาษี แบบอัตโนมัติ ซึ่งจะทำให้คุณทราบได้ทันทีว่าจะต้องจ่ายภาษีเมื่อใด",
				"Automatic Tax Calculation for Employees and Company":
					"ระบบคำนวณภาษีอัตโนมัติสำหรับพนักงานและบริษัท",
				"Provident Fund": "แสดงข้อมูลของกองทุนสำรองเลี้ยงชีพ",
				"Investment Recommendations":
					"แนะนำการลงทุนต่างๆ เพื่อเป็นประโยชน์ต่อการลดหย่อนภาษี (ทั้งการลงทุนระยะสั้นและระยะยาวรวมทั้งประกันสุขภาพ) (เร็วๆนี้)",
				"Employee Database & Records":
					"จัดเก็บข้อมูลพนักงานและเอกสารอย่างเป็นระบบ",
				"Comprehensive Record Keeping of current and past Employees":
					"จัดเก็บข้อมูลพนักงานของบริษัททั้งพนักงานปัจจุบันและอดีตอย่างเป็นระบบ ทำให้ลดการใช้เวลาในการหาข้อมูลและไม่ต้องกังวลกับเรื่องข้อมูลสูญหายอีกต่อไป",
				"Employee Information Database":
					"จัดเก็บข้อมูลพนักงานอย่างเป็นระบบและอัพเดตข้อมูลอยู่เสมอ",
				"Organizational Chart": "มีการจัดทำแผนผังองค์กรที่เข้าใจง่าย",
				"Company Announcements": "ประกาศข่าวสารออนไลน์ของบริษัท",
				"Keep you Employees Informed with the Latest Company Announcements":
					"อัปเดตประกาศข่าวสารต่างๆของบริษัททางแอปพลิเคชัน เพื่อให้พนักงานของคุณได้รับข่าวสารได้อย่างรวดเร็ว",
				"Announce Company Events, Holidays and more":
					"ประกาศกิจกรรมต่าง, วันหยุด และอื่นๆ",
				"Company Announcements through":
					"ประกาศข่าวสารออนไลน์ Push-Notification (เร็วๆนี้)",
				"Clock-In & Clock-Out Employee Self Service (ESS)":
					"ระบบบันทึกเวลาเข้าออกงานผ่านแอปพลิเคชัน",
				"Clock-In & Clock-Out Information is embedded in our HR-Platform so You Can Always Keep Track of Time":
					"ระบบบันทึกเวลาเข้าออกงานผ่านแอปพลิเคชันที่เชื่อมต่อกับระบบ Dashboard ของฝ่ายบุคคล ทำให้ฝ่ายบุคคลสามารถอัพเดตข้อมูลการเข้าออกงานของพนักงานได้ตลอดเวลา",
				"GPS based Clock-In & Clock-Out":
					"การใช้ GPS หรือ Finger scan ในการบันทึกเวลาเข้าออกงานของพนักงาน",
				"Location-Selfie based Clock-In & Clock-Out":
					"ระบบบันทึกเวลาเข้าออกของพนักงานจากสถานที่และรูปถ่ายเซลฟี่",
				"Data Overview on the HR Dashboard":
					"แสดงเวลาเข้าออกงานของพนักงานแต่ละคนผ่านทาง Dashboard ของฝ่ายบุคคล",
				"Employee Self-Onboarding (ESS)": "การอัพเดตข้อมูลพื้นฐานพนักงาน (ESS)",
				"HR saves time as Employees Directly Enter":
					"พนักงานสามารถเพิ่มข้อมูลพื้นฐานของตนเองสู่ระบบได้โดยตรง นั้นทำให้ลดเวลาของฝ่ายบุคคลในการกรอกข้อมูลพนักงาน",
				"Customizable Data Fields":
					"ระบบรองรับการเพิ่มหรือลดข้อมูลที่จำเป็นสำหรับแต่ละองค์กรได้",
				"Employee Self-Onboarding":
					"พนักงานสามารถเพิ่มข้อมูลพื้นฐานได้ด้วยตัวเอง",
				"Employee Requests (ESS)":
					"การส่งคำขอต่างๆของพนักงานผ่านทาง แอปพลิเคชัน (ESS)",
				"Employees are Able to Submit a Multitude":
					"พนักงานสามารถ ส่งคำขอต่างๆได้ผ่านแอปพลิเคชัน ซึ่งคำขอจะถูกส่งไปยังฝ่ายบุคคลโดยตรง ทำให้เกิดความสะดวกและรวดเร็วในการทำงานมากขึ้น",
				"Customizable Approval Process for the Employer with Multiple Steps":
					"สามารถจัดการการอนุมัติได้ว่าจะกำหนดผู้มีอำนาจในการอนุมัติในคำขอแต่ละประเภท",
				"Holiday Request": "การส่งคำขอวันลา",
				"Expense Request": "การส่งคำขอค่าใช้จ่าย",
				"Overtime Request": "การส่งคำขอการอนุมัติการทำงานล่วงเวลา",
				"Advance Cash Request for Business Purposes":
					"การส่งคำขอปฏิบัติงานนอกสถานที่ ",
				"Field Work Request with Remote Clock-In":
					"การส่งคำขอการเบิกเงินทดรองจ่าย",
				"Employee Referrals": "การสรรหาพนักงานใหม่",
				"Find the best Employees for your Company from your own Network":
					"การสรรหาพนักงานใหม่เข้าสู่องค์กรผ่านโซเชียลมีเดีย",
				"Employees Share Job Vacancies on Social Media":
					"พนักงานสามารถแชร์ตำแหน่งว่างงานขององค์กรลงโซเชียลมีเดียได้ ทำให้ง่ายต่อการสรรหาพนักงานเข้าสู่องค์กร",
				"Government Forms": "เอกสารของภาครัฐ",
				"Payroll Payment Processing": "การจ่ายเงินเดือนผ่านระบบอัตโนมัติ",
				"Manage All Your Branches2":
					"ระบบมีแบบฟอร์มเอกสารทุกชนิดที่ใช้กับหน่วยงานรัฐบาลและมีการอัพเดทตลอดเวลา",
				"PND Form": "แบบฟอร์มการลดหย่อนภาษี (PND)",
				"SSOs Form": "แบบฟอร์มประกันสังคม (SSOs)",
				Others: "แบบฟอร์มอื่นๆ",
				Other: "อื่นๆ (โปรดระบุ)",
				"WHY USE MONEYTABLE?": "ทำไมต้อง MoneyTable ?",
				"LET’S US HELP YOU": "ให้เราได้เป็นส่วนร่วมในการพัฒนาองค์กรของคุณ",
				"Send us your information, Our team will help you reach your goals":
					"บอกข้อมูลหรือปัญหาที่คุณสงสัย ทีมงานของเราจะช่วยคุณให้คุณไปถึงเป้าหมายทางธุรกิจของคุณ",
				"contact us": "ติดต่อเราตอนนี้",
				"Give us you information":
					"สอบถามข้อมูลหรือปัญหาที่คุณสงสัย ทีมของเราพร้อมที่จะช่วยคุณเสมอ",
				"Your Name": "ชื่อ - นามสกุล",
				"Your Message": "ข้อความของคุณ",
				"Your number": "เบอร์โทรศัพท์",
				"Email Address": "อีเมล์",
				"Subject of the Email": "หัวข้อ",
				"Company name": "ชื่อบริษัท",
				Address: "ที่อยู่",
				District: "ตำบล",
				Amphur: "อำเภอ",
				Province: "จังหวัด",
				Zipcode: "รหัสไปรษณีย์",
				Business: "ประเภทธุรกิจ",
				"Contact information": "ข้อมูลติดต่อ",
				"Corporate Information": "ข้อมูลองค์กร",
				"Other information": "ข้อมูลอื่นๆ",
				"Employee number": "จำนวนพนักงาน",
				Channel: "คุณรู้จักเราจากช่องทางใด",
				"Are you a Microsoft Office 365 customer?":
					"คุณเป็นลูกค้า Microsoft Office 365 หรือไม่",
				"No, but interested to use Microsoft Office 365.":
					"ไม่เป็นแต่สนใจจะใช้ Microsoft Office 365",
				"Do not be and ignore Microsoft Office 365":
					"ไม่เป็นและไม่สนใจ Microsoft Office 365",
				"Yes, I do": "เป็น",
				Welcome: "ยินดีต้อนรับ",
				"Subscription requires a promotional code.":
					"การสมัครสมาชิกจำเป็นต้องใช้รหัสโปรโมชัน",
				"Do you have a promo code?": "คุณมีรหัสโปรโมชันแล้วหรือยัง ?",
				"Request a promotional code": "ขอรหัสโปรโมชันเพื่อเข้าใช้ระบบ",
				"I already have a promo code.": "ฉันมีรหัสโปรโมชันแล้ว",
				email: "อีเมล์",
				line: "ไอดีไลน์",
				tel: "เบอร์โทรศัพท์",
				other: "ช่องทางอื่นๆในการติดต่อ",
				product: "ผลิตภัณฑ์",
				about: "เกี่ยวกับเรา",
				"Select one": "เลือกหนึ่งรายการ",
				aboutus: "เกี่ยวกับบริษัท",
				// "Financial_Policy": "นโยบายทางการเงิน",
				"Auto payroll payment processing so, your accountant don’t have to go to bank anymore":
					"ระบบสามารถจ่ายเงินเดือนผ่านระบบอัตโนมัติทำให้ฝ่ายบัญชีไม่ต้องยุ่งยากในการทำธุรกรรมอีกต่อไป",
				"Support online transaction processing by leading banks in Thailand":
					"รองรับการทำธุรกรรมออนไลน์โดยธนาคารชั้นนำของประเทศไทย",
				careers: "ร่วมงานกับเรา",
				term: "ข้อตกลงและเงื่อนไขบริการ",
				privacy: "นโยบายความเป็นส่วนตัว",
				Social: "ช่องทางการติดต่อ",
				Request: "ขอทดลองใช้ระบบ",
				Contact: "ขอทดลองใช้ระบบ",
				Learn: "ขอรายละเอียดเพิ่มเติม",
				Sendus: "ติดต่อเรา",
				Let: "ติดต่อเรา",
				Log: "เข้าสู่ระบบ",
				"Somthing went wrong": "เกิดข้อผิดพลาด",
				Read: "สอบถามข้อมูลเพิ่มเติม",
				OR: "หรือ",
				ContactUs: "ขอทดลองใช้ระบบ",
				Requesta: "ขอทดลองใช้ระบบ",
				Send: "ส่ง",
				"Back to home": "กลับหน้าแรก",
				"Data has been successfully sent.": "ส่งข้อมูลเรียบร้อยแล้ว",
				"Please wait for a response from us.": "กรุณารอการติดต่อกลับจากทีมงาน",
				"we are Moneytable": "เราคือ Moneytable",
				vision: "วิสัยทัศน์บริษัท",
				ourStory: "เกี่ยวกับเรา",
				ourterm: "ทีมงานของเรา",
				about1:
					"บริษัท มันนี่เทเบิล จำกัด (มหาชน) ก่อตั้งขึ้นเมื่อปี 2559 เพื่อมอบประสบการณ์การใช้แพลตฟอร์มด้านการบริหารงานบุคคล (HR) และแพลตฟอร์มด้านการเงิน (Finance) เพื่อสร้างคุณค่าให้กับองค์กร และพนักงาน ตอบโจทย์ยุคแห่งเทคโนโลยีและนวัตกรรม ด้วยการสร้างสภาพแวดล้อมในการทำงานในยุคดิจิทัล ให้เกิดความคล่องตัวและทันต่อยุคสมัย ผ่านการระดมทุนจาก Venture Capital ชั้นนำของเอเชียและการฟอร์มทีมที่แข็งแกร่ง ปัจจุบันเราได้รับการไว้วางใจจากบริษัทชั้นนํามากมาย",
				about2:
					"“มุ่งสู่การเป็นแพลตฟอร์มด้านบริหารงานบุคคลและการเงิน ที่ใหญ่ที่สุดในเอเชีย”",
				about3:
					"ทีมงานที่มีความสามารถและมีประสบการณ์ยาวนาน มากกว่า 60 ชีวิต จากองค์กรชั้นนำทั้งในและต่างประเทศ ทั้งในแวดวงธุรกิจ การเงิน การธนาคาร และเทคโนโลยี อาทิ McKinsey, SAP, HSBC, Barclays, BAY, TISCO, AIG, AIA, Accenture, Allianz, aCommerce, VM Ware, และ Lazada ที่ครอบคลุมความเชี่ยวชาญด้านเทคโนโลยี การเงิน การบริหารจัดการ การขาย การตลาดและการสื่อสาร ในการพัฒนาดิจิทัล แพลตฟอร์ม",
				dc_contactus_title: "ติดต่อสอบถามข้อมูลเพิ่มเติม",

				"contact-form-name-label": "ชื่อของคุณ?",
				"contact-form-company-name-label": "ชื่อบริษัทของคุณ?",
				"contact-form-number-of-employees-label": "จำนวนพนักงาน?",
				"contact-form-position-label": "ตำแหน่งของคุณในบริษัท",
				"contact-form-email-label": "อีเมล์ที่ต้องการให้เราตอบกลับ?",
				"contact-form-phone-label": "เบอร์โทรศัพท์ที่ต้องการให้เราติดต่อกลับ?",
				"contact-form-subject-label": "หัวข้อเรื่องที่ต้องการติดต่อ",
				"contact-form-please-select": "กรุณาเลือก",
				"contact-form-message-label":
					"ฉันอยู่ที่นี่โปรดบอกสิ่งที่อยู่ในใจของคุณ?",
				"contact-form-header1": "ข้อมูลของคุณ",
				"contact-form-header2": "ข้อความของคุณ",
				"contact-form-not-sure-yet": "ไม่แน่ใจ",
				"contact-form-business-owner": "เจ้าของธุรกิจ",
				"contact-form-human-resources": "ฝ่ายบุคคล",
				"contact-form-investor": "นักลงทุน",
				"contact-form-employee": "พนักงาน",
				"contact-form-agent": "ตัวแทน",
				"contact-form-request-to-use-daycash": "ต้องการใช้งาน DayCash",
				"contact-form-need-info-daycash": "ต้องการข้อมูลเกี่ยวกับ DayCash",
				"contact-form-need-help-daycash":
					"ต้องการความช่วยเหลือเกี่ยวกับการใช้งาน DayCash",
				"contact-form-need-suggestion-money-debt":
					"ต้องการคำแนะนำในการจัดการเงินและภาระหนี้",
				"contact-form-would-like-to-be-partner-agent":
					"ต้องการเป็นพันธมิตรหรือตัวแทนกับ MoneyTable",
				"contact-form-would-like-invest-moneytable":
					"ต้องการลงทุนในธุรกิจของ MoneyTable",
				"contact-form-name-placeholder": "ชื่อเต็ม",
				"contact-form-submit": "ส่งแบบฟอร์ม",
				"contact-form-phone-placeholder": "เบอร์โทรติดต่อ",

				Careers: "ร่วมงานกับเรา",
				"Your next job should offer more than just free lunch, pool tables and happy hours. Reach your potential with a career at MoneyTable.":
					"ทำงานกับเราคุณจะได้สัมผัสสวัสดิการที่ดีกว่า เช่น อาหารเที่ยงฟรี, โต๊ะพลูเพื่อผ่อนคลายจาก การทำงาน Happy hours ในทุกสัปดาห์ และอื่นๆอีกมากมาย พัฒนาศักยภาพของคุณไปอีกขั้น ก้าวไปพร้อมกับเรา",
				career_title: "เพราะทีมงานของเราเป็นมากกว่าพนักงาน",
				Fun: "ความสนุกในการทำงาน",
				"Food & Happy Hour": "อาหารและ Happy hours",
				"Health & Business": "สวัสดิการด้านสุขภาพและวันลา",
				Culture: "สภาพแวดล้อมในการทำงาน",
				Training: "การฝึกอบรม",
				"Work Off-Site": "การดูงานเพื่อเปิดประสบการณ์",
				"Expect frequent   hours, work off-sites, pool table and table tennis tournaments. We play as hard as we work.":
					"เวลาเข้างานที่ยืดหยุ่น, สามารถทำงานนอกสถานที่ได้, การแข่งขันพูลและปิงปอง ความผ่อนคลายในการทำงาน",
				"Lunch is delivered every day at noon, eatas much as your heart desires. Every Friday satisfy your sweet tooth with our end of the week treats.":
					"เรามีอาหารเที่ยงให้คุณทุกเที่ยง และทุกวันศุกร์บ่าย เรามีอาหารว่างมื้อพิเศษให้แก่ทุกๆคน",
				"Great health benefits are available as well as business days off.":
					"สวัสดิการด้านสุขภาพและวันลาที่ดีกว่าที่อื่นๆ",
				"Evolve as a professional in a demanding but caring environment. We take pride in our commitment to teamwork - at MoneyTable you will always be part of a team that isstronger than the sum of its parts.":
					"เราเชื่อมั่นในการทำงานเป็นทีม เพื่อการทำงานอย่างมีประสิทธิภาพ ร่วมมาเป็นส่วนหนึ่งของทีมที่แข็งแกร่งของเรา",
				"Training by leading tech icons and business leaders.":
					"เราเชื่อมั่นในการพัฒนาบุคคลากรของเรา ดังนั้นคุณจะได้รับการฝึกอบรมในด้านที่คุณสนใจจากบุคคลที่มีประสบการณ์มากมาย",
				"Take company retreats and work off-sites. In the past we took trip to Thai beach resorts and the Silicon Valley in California.":
					"นอกจากการทำงานแล้ว เรายังให้ความสำคัญกับการสร้างความสุขและเปิดประสบการณ์ใหม่ๆแก่พนักงาน ซึ่งจะมีทั้งการออกทริปทั้งในประเทศไทยและต่างประเทศ (Silicon Valley ใน California)",
				"MoneyTable is Right for You if": "เราคือบริษัทที่ใช่สำหรับคุณถ้าหาก",
				"You are motivated to help people reach financial security":
					"คุณมุ่งมั่นที่จะช่วยยกระดับความมั่นคงทางการเงินแก่ผู้คน",
				"You are smart, curious and self motivated":
					"คุณมีความอยากที่จะพัฒนาตนเอง หรือเรียนรู้สิ่งใหม่ๆ",
				"You exercise good judgement and take responsibility for your work":
					"มีความตรงไปตรงมาในการทำงานและมีความรับผิดชอบ",
				"You are an independent problem solver and love to work in teams":
					"มีความสามารถในการแก้ไขปัญหาเฉพาะหน้าและรักที่จะทำงานเป็นทีม",
				"Current Career Openings": "ตำแหน่งที่เปิดรับในขณะนี้",
				APPLY: "สมัครตำแหน่งนี้",
				"contact-us-package": "ติดต่อเรา",
				tm_product: "ผลิตภัณฑ์ของเรา",
				tm_aboutus: "ความรู้ทางการเงิน",
				tm_blog: "บทความ",
				tm_contactus: "ติดต่อเรา",
				tm_activity: "กิจกรรมของเรา",
				hrnews: "รอบรู้ด้าน HR",
				finews: "แวดวงการเงิน",
				hero_mt: "แอปพลิเคชันขอสินเชื่อสำหรับพนักงานในองค์กร",
				hero_mt_1: "เพื่อสวัสดิการ และชีวิตที่ดีขึ้น",
				hero_hr: "โปรแกรม HR ที่ช่วยลดเวลาการทำงาน",
				hero_hr_1: "เสริมประสิทธิภาพให้กับองค์กร",
				f_whovare: "รู้จักเรา",
				f_whatvdo: "ธุรกิจของเรา",
				f_ourvi: "วิสัยทัศน์",
				f_ourmis: "พันธกิจ",
				f_company: "บริษัทของเรา",
				aboutmt: "เกี่ยวกับมันนี่เทเบิล",
				customers: "ลูกค้าที่ไว้วางใจ",
				tandc: "เงื่อนไขและข้อตกลงในการใช้บริการ",
				privacypolicy: "นโยบายความเป็นส่วนตัว",
				tm_productDC: "DayCash",
				f_coreval: "คุณค่าองค์กร",
				f_ourtea: "ทีมงานของเรา",
				f_jointeam: "ร่วมงานกับเรา",
				f_privac: "นโยบายความปลอดภัย",
				f_parther: "พันธมิตร",
				f_blog: "บทความน่าสนใจ",
				f_tips: "สาระน่ารู้",
				f_vocal: "ศัพท์น่ารู้",
				f_contact: "สอบถามข้อมูลทั่วไป",
				f_contacthr: "ขอทดลองใช้ HRTable",
				f_contactmt: "ขอทดลองใช้ MoneyTable",
				f_condition: "ข้อตกลงและเงื่อนไขบริการ",
				hero_line1: "เราสร้าง",
				hero_line2: "ดิจิทัล แพลตฟอร์ม อันชาญฉลาด",
				hero_line3: "เพื่อการทำงานที่ทันสมัย",
				f_association: "สมาคมต่างๆ",
				f_financial: "สถาบันการเงิน",
				f_software: "ผู้ผลิตซอฟต์แวร์",
				f_insurance: "บริษัทประกัน",
				mt_detail1: "MoneyTable แอปพลิเคชันขอสินเชื่อ",
				mt_detail2: "ช่วยอำนวยความสะดวกด้านการเงินของพนักงานของคุณ",
				mt_detail3:
					"จากช่องทางทางการเงินที่เชื่อถือได้ ในอัตราดอกเบี้ยต่ำ นำมาสู่ความสุขในการทำงาน",
				mt_detail4: "ของทั้งพนักงานและเจ้าของธุรกิจ",
				hero_s2_line1: "Digital HR Platform",
				hero_s2_line2: "ที่จ่ายเงินเดือนผ่านระบบอัตโนมัติ",
				hero_s2_line3: "ลดความยุ่งยากในการทำงานของคุณ",
				hero_s3_line1: "Digital HR Platform",
				hero_s3_line2: "บันทึกเวลาเข้าออกงานผ่าน APP",
				hero_s3_line3: "ผ่าน GPS และ Finger scan",
				hero_s4_line1: "Digital HR Platform",
				hero_s4_line2: "ที่เชื่อมต่อ VDO Call ผ่าน Skype",
				hero_s4_line3: "สามารถประชุม ได้ทุกที่ ทุกเวลา",
				hero_s5_line1: "Digital HR Platform",
				hero_s5_line2: "บนระบบ Cloud (Microsoft AZURE)",
				hero_s5_line3: "มาตรฐานความปลอดภัยระดับโลก",
				hero_learnmore: "เรียนรู้เพิ่มเติม",
				"contact-us-package-detail":
					"เพียงกรอกข้อมูล และรอการติดต่อกลับจากทีมงานของเรา",
				"select-subject": "เลือกหัวข้อที่ต้องการ *",
				"more-infomation-mt": "สอบถามข้อมูลเพิ่มเติมของ MoneyTable",
				"more-infomation-hr": "สอบถามข้อมูลเพิ่มเติมของ HRTable",
				"trail-moneytable": "ขอทดลองใช้ระบบ MoneyTable",
				"trail-hrtable": "ขอทดลองใช้ระบบ HRTable",
				"select-other": "อื่นๆ",
				"map-address": "142 ถ.พระราม 9, ห้วยขวาง กรุงเทพฯ 10310",
				hot_deal: "โปรโมชันพิเศษ!",
				mission: "พันธกิจ",
				mission_1: "มุ่งพัฒนาผลิตภัณฑ์แบบครบวงจร ที่ตอบโจทย์ไลฟ์สไตล์สมัยใหม่",
				mission_2: "ส่งมอบเทคโนโลยีและนวัตกรรมด้านการเงินที่ดีที่สุด",
				mission_3: "สร้างประสบการณ์และการบริการที่ดี สำหรับผู้ใช้งานทุกคน",
				corevalue: "คุณค่าที่เราส่งมอบ",
				corevalue_1: "ความน่าเชื่อถือ",
				corevalue_2: "ความเป็นมืออาชีพ",
				corevalue_3: "การสร้างนวัตกรรม",
				corevalue_4: "ความสะดวกสบาย",
				corevalue_5: "การกระจายศูนย์",
				corevalue_6: "ทัศนคติเชิงบวก",
				"corevalue_1-1":
					"ช่วยเพิ่มกระแสเงินสดระหว่างเดือนให้กับพนักงาน เมื่อพวกเขาต้องการ",
				"corevalue_2-1":
					"ช่วยเพิ่มตัวเลือกของเงินทุนที่พร้อมนำไปใช้จ่ายให้พนักงาน ลดโอกาสการกู้ยืมเงินดอกเบี้ยสูง",
				"corevalue_3-1":
					"ช่วยให้นายจ้างสามารถให้สวัสดิการ “เบิกเงินค่าจ้างก่อนวันเงินเดือนออก” ให้แก่พนักงาน โดยไม่เป็นภาระทางการเงิน และความเสี่ยงของบริษัท",
				"corevalue_4-1":
					"เปิดโอกาสให้สถาบันการเงินสามารถเข้าถึงตลาดในกลุ่มพนักงานระดับบริการ ขนาดใหญ่ในประเทศไทยและเอเชียตะวันออกเฉียงใต้",
				"corevalue_5-1": ">> ลดขั้นตอนการทำงานให้เกิดประโยชน์สูงสุดต่อองค์กร",
				"corevalue_6-1": ">> ทำงานด้วยความมุ่งมั่น และคิดบวกอยู่เสมอ",
				followus: "ติดตามเราได้ที่",
				testimonail_text: "เรื่องราวความประทับใจ",
				tm_testimonial: "Testimonial",
				beam_name: "ตฤบดี อรุณานนท์ชัย",
				beam_posx: "(CEO)",
				beam_quote:
					"Serial Entrepreneur ที่มีประสบการณ์มากกว่า 10 ปี ในธุรกิจ การเงินการธนาคาร เชี่ยวชาญด้าน Digital Consumer, AI และ สื่อ",
				don_name: "ปิยะ จูฑา",
				don_pos: "ประธานเจ้าหน้าที่บริหารด้านผลิตภัณฑ์",
				don_posx: "(CPO)",
				don_quote:
					"ประสบการณ์กว่า 18 ปี ในด้านการพัฒนาซอฟต์แวร์ระดับองค์กร และการเชื่อมต่อระบบ",
				jim_name: "กฤตชญา โกมลสิทธิ์เวช",
				jim_pos: "ประธานเจ้าหน้าที่บริหารด้านปฏิบัติการ",
				jim_posx: "(COO)",
				jim_quote:
					"ประสบการณ์กว่า 18 ปี ในด้านการเชื่อมต่อระบบ การวางระบบธุรกิจ และการบริหารจัดการ",
				jon_name: "ณัฐ มาลาสิทธิ์",
				jon_pos: "ประธานเจ้าหน้าที่บริหารด้านเทคโนโลยี",
				jon_posx: "(CTO)",
				jon_quote:
					"ผู้เชี่ยวชาญด้านระบบ SAP HR และ Web App จากหลากหลายโครงการขนาดใหญ่ทั้งในไทยและต่างประเทศมา",
				"jon_quote-1": "มากว่า 17 ปี",
				pop_name: "ปรีดี นุกุลสมปรารถนา",
				pop_pos: "ประธานเจ้าหน้าที่บริหารด้านการสื่อสาร",
				pop_posx: "(CCO)",
				pop_quote:
					"นักการตลาดและสื่อสารองค์กร ให้กับหน่วยงานภาครัฐและภาคเอกชน ในธุรกิจอสังหาริมทรัพย์ อุตสาหกรรมยานยนต์ และธุรกิจเครือข่าย มากกว่า 14 ปี ที่ปรึกษา วิทยากรและอาจารย์พิเศษด้านการสื่อสารการตลาดและการสร้างแบรนด์",
				lookpad_name: "ศิริวาสน์ สราวิช",
				lookpad_pos: "หัวหน้าทีมปฏิบัติการ",
				lookpad_quote:
					"ประสบการณ์กว่า 10 ปี ในงานด้านการดูแลระบบ จากธุรกิจการพัฒนาซอฟต์แวร์ ในอุตสาหกรรมโรงแรมการท่องเที่ยว งานบริหารบุคคล และการบิน",
				patrick_quote:
					"ประสบการณ์กว่า 12 ปีในการบริหารจัดการโครงการและผลิตภัณฑ์ในองค์กรระดับนานาชาติ และธุรกิจสตาร์ทอัพที่มีการเติบโตอย่างรวดเร็ว",
				tong_name: "ปณยา เพ็งบุญ",
				tong_pos: "หัวหน้าทีมพัฒนาผลิตภัณฑ์ด้าน HR",
				tong_quote:
					"ประสบการณ์กว่า 8 ปี ในด้านการพัฒนา Digital product ในองค์กรขนาดใหญ่",
				wut_name: "วุฒิชัย อินแสง",
				wut_pos: "หัวหน้าทีมพัฒนาผลิตภัณฑ์ด้าน HR",
				wut_quote: "ประสบการณ์กว่า 7 ปี ในด้านการพัฒนาเว็บ",
				"wut_quote-1": "แอพพลิเคชั่น",
				yod_name: "พิศาล ฤชาทวีรุ่งโรจน์",
				yod_pos: "หัวหน้าทีมพัฒนาผลิตภัณฑ์ด้านการเงิน",
				yod_quote:
					"ประสบการณ์ 16 ปี ในด้านพัฒนาซอฟแวร์ระดับนานาชาติและบริหารโครงการ",
				andy_name: "อัครเดช (แอนดี้) ดิษยเดช",
				andy_pos: "หัวหน้าทีมพัฒนาธุรกิจ",
				andy_quote:
					"กว่า 30 ปี ในสายงานบริหารและวางกลยุทธ์การขาย จากแวดวงการเงินระดับโลกทั้งใน ฮ่องกง สิงคโปร์ และไทย รวมถึงตลาดเอเชียตะวันออกเฉียงใต้",
				contact_us_hrtable: "โปรดกรอกข้อมูลให้ครบถ้วน",
				contact_us_hrtable2: "เพื่อให้เจ้าหน้าที่ติดต่อกลับ",
				contact_mt: "ติดต่อผลิตภัณฑ์ MoneyTable",
				contact_mt2:
					"กรุณากรอกข้อมูลให้ครบถ้วน เพื่อให้ทีมงานผลิตภัณฑ์ MoneyTable ติดต่อกลับ",
				contactus_now: "ติดต่อเราตอนนี้",
				hot_deal_p1: "โปรโมชัน",
				hot_deal_p2: "พิเศษ",
				seeall_promotion: "ดูโปรโมชันทั้งหมด",
				seeall_promotion_more: "รายละเอียดเพิ่มเติม",
				viewmorestaff: "ทีมงานมืออาชีพทั้งหมดของเรา",
				hrt_hero_1: "โปรแกรมบริหารงานบุคคล",
				hrt_hero_2: "ที่ตอบโจทย์การทำงานสมัยใหม่",
				hrt_hero_3: "มุ่งพัฒนาองค์กรให้ก้าวสู่ยุคดิจิทัล",
				hero_btn_trial: "ทดลองใช้ระบบ",
				hero_btn_login: "เข้าสู่ระบบ",
				hero_new_bottom: "ตอบโจทย์การทำงานกับ ฟีเจอร์หลัก",
				hero_new_bottom_feature_1:
					"ระบบคำนวณเงินเดือน | ระบบบันทึกเวลาเข้า - ออก | ระบบจัดการข้อมูลพนักงาน",
				btn_download_brochure: "ดาวน์โหลดโบรชัวร์",
				hr_detail_title_desc:
					"โปรแกรมบริหารงานบุคคล แบบอัตโนมัติที่ง่ายและรวดเร็ว",
				หมดปัญหาเรื่องงานเอกสาร: "หมดปัญหาเรื่องงานเอกสาร",
				nt_001:
					"แทนที่การใช้กระดาษด้วยเอกสารแบบดิจิทัล สะดวกต่อการจัดเก็บและแก้ไข",
				"ระบบอัตโนมัติแบบ Real-time": "ระบบอัตโนมัติแบบ Real-time",
				nt_002:
					"ตอบสนองการทำงานในยุคดิจิทัล 4.0 สร้างความสะดวกในการทำงาน รวดเร็ว เพียงปลายนิ้วสัมผัส",
				"ปลอดภัย ไร้กังวล": "ปลอดภัย ไร้กังวล",
				nt_003:
					"ระบบ Digital Ecosystem เก็บรักษาข้อมูลบน Cloud ที่มีความปลอดภัยสูง มาตรฐานเดียวกับธนาคาร",
				ระบบการทำงาน: "ฟีเจอร์หลักของโปรแกรม",
				nt_004: "ระบบคำนวณเงินเดือนอัตโนมัติ",
				nt_005:
					"สามารถคำนวณเงินเดือนจากข้อมูลต่างๆ อาทิ รายได้ รายหัก ผลตอบแทน และพนักงานสามารถดูรายละเอียดจากแอปพลิเคชัน (E-Payslip) ได้ด้วยตนเอง",
				btn_trial: "ทดลองใช้ระบบ",
				nt_006: "ระบบบันทึกเวลาเข้า-ออก",
				nt_007:
					"บริหารจัดการ การเข้า-ออกงาน ผ่านระบบ GPS/Finger แบบ Real-time เหมาะกับธุรกิจหลากหลายประเภท",
				nt_008: "ระบบจัดการข้อมูลพนักงาน",
				nt_009:
					"ทุกข้อมูลของพนักงานจะได้รับการจัดเก็บให้ง่ายต่อการค้นหาและจัดการ รองรับระบบโครงสร้างองค์กร พนักงานสามารถจัดการข้อมูลส่วนบุคคลได้ด้วยตัวเอง (Employee Self-Service : ESS) ",
				บริหารช่วงเวลาทำงาน: "บริหารช่วงเวลาทำงาน",
				nt_010:
					"ครอบคลุมการทำงานในช่วงเวลาที่ต่างกัน อาทิ การทำงานช่วงเช้า บ่าย กลางคืน รองรับการปรับเปลี่ยนสำหรับหลายประเภทธุรกิจ",
				ส่งคำขอและอนุมัติการลา: "ส่งคำขอและอนุมัติการลา",
				nt_011:
					"สามารถส่งคำขอ และอนุมัติการลาประเภทต่างๆ อาทิ ลากิจ ลาป่วย ลาพักร้อน ผ่านแอปพลิเคชันได้อย่างสะดวกรวดเร็วและ Real-time",
				การสื่อสารในองค์กร: "การสื่อสารในองค์กร",
				nt_012:
					"ไม่พลาดทุกการสื่อสาร ด้วยฟีเจอร์ประกาศภายในองค์กร ผ่านแอปพลิเคชัน VDO Call ผ่าน Skype ฟีเจอร์เด็ดจาก Office365",
				สรรหาพนักงานใหม่: "สรรหาพนักงานใหม่",
				nt_013:
					"เพิ่มและแชร์ตำแหน่งว่างงานในองค์กร ผ่านระบบและสามารถทำลิ้งค์ไปวางที่เว็บไซต์ต่างๆได้อย่างง่ายดาย",
				ข้อมูลติดต่อภายในบริษัท: "ข้อมูลติดต่อภายในบริษัท",
				nt_014:
					"สะดวกทุกการสื่อสาร ผ่านการสร้างรายชื่อ และเบอร์ติดต่อพนักงานผ่านแอปพลิเคชัน",
				ไม่สนใจ: "ไม่สนใจ",
				ดาวน์โหลดเอกสารจากหน่วยงานของรัฐ: "ดาวน์โหลดเอกสารจากหน่วยงานของรัฐ",
				nt_015:
					"ระบบมีแบบฟอร์มเอกสารทุกชนิดที่ใช้กับหน่วยงานรัฐบาล และมีการอัพเดทตลอดเวลา",
				สอบถามข้อมูล: "สอบถามข้อมูล",
				เพิ่มเติม: "เพิ่มเติม",
				ติดต่อเราเพื่อขอทดลองใช้ระบบ: "ติดต่อเราเพื่อขอทดลองใช้ระบบ",

				mt_hero_1: "แอปพลิเคชันขอสินเชื่อ",
				mt_hero_2: "ช่วยอำนวยความสะดวกให้พนักงานของคุณ",
				mt_hero_3: "ได้เข้าถึงช่องทางการเงินที่เชื่อถือได้และอัตราดอกเบี้ยต่ำ",
				nt_101: "คำขอสินเชื่อมีอัตราการอนุมัติเกือบ 100% ",
				nt_102: "ผ่านแอปพลิเคชันที่สะดวกและรวดเร็ว ",
				nt_103: "จากแหล่งสินเชื่อที่มีอัตราดอกเบี้ยต่ำที่สุด ",
				nt_104: "ผ่านระบบการจ่ายเงินคืนด้วยระบบอัตโนมัติ ",
				เปอร์เซ็นต์ในการอนุมัติสูง: "เปอร์เซ็นต์ในการอนุมัติสูง",
				เข้าถึงแหล่งสินเชื่อได้ง่าย: "เข้าถึงแหล่งสินเชื่อได้ง่าย",
				อัตราดอกเบี้ยที่เป็นธรรม: "อัตราดอกเบี้ยที่เป็นธรรม",
				ระบบการจ่ายเงินคืนแสนสะดวก: "ระบบการจ่ายเงินคืนแสนสะดวก",
				mt_detail_title_desc: "แอปพลิเคชันขอสินเชื่อเพื่อพนักงานของคุณ",
				ทำไมต้องMONEYTABLE: "ทำไมต้อง MONEYTABLE ?",
				สมัครง่าย: "สมัครง่าย",
				อนุมัติไว: "อนุมัติไว",
				รับเงินทันใจ: "รับเงินทันใจ",
				ได้ใจพนักงาน: "ได้ใจพนักงาน",
				nt_105: "ดอกเบี้ยที่เป็นธรรม และอัตราการอนุมัติสูง ",
				nt_106:
					"ข้อเสนอสินเชื่อที่ดีที่สุด เพื่อให้คุณได้รับการอนุมัติคำขอ ได้เกือบ 100% ลดความกังวลด้านปัญหาทางการเงิน",
				nt_107: "ระบบคำนวณอัตโนมัติ",
				nt_108:
					"คุณสามารถเชื่อมต่อกับโปรแกรมของเรา เพื่อให้พนักงานของคุณสามารถเข้าถึงแหล่งสินเชื่อได้ ซึ่งการชำระเงินคืนจะทำการตัดจากระบบอัตโนมัติ ทำให้คุณไม่ต้องเสียเวลาไปทำธุรกรรมที่ธนาคาร",
				ติดต่อเราตอนนี้: "ติดต่อเราตอนนี้",
				namtan_pos: "หัวหน้าทีมขาย",
				namtan_name: "ชัชรวีย์ เจริญสุข",
				namtan_quote:
					"ประสบการณ์ 6 ปีในสายงานด้านการขายและพัฒนาการตลาดในด้านธุรกิจ sme และ startup",
				pam_pos: "กรรมการผู้จัดการ",
				pam_posx: "(MD)",
				pam_name: "ณัฏฐินี ศิริรัตนพล",
				pam_quote:
					"Seasoned Entrepreneur & Experienced Banker with background in Treasury & Global Markets",

				dc_hero_1: "แอปพลิเคชั่น สวัสดิการด้านการเงิน",
				dc_hero_2: "เพื่อพนักงานที่ครบครัน ทั้งการบริหาร",
				dc_hero_3: "จัดการเงินเดือน และ ค่าใช้จ่ายฉุกเฉิน ",
				dc_hero_contact: "ติดต่อสอบถามข้อมูลเพิ่มเติม",

				dc_detail_teaser: "ผู้เชี่ยวชาญด้านสวัสดิการทางการเงิน...เพื่อพนักงาน",
				dc_detail_item1_header: "เบิกเงินเดือนล่วงหน้า",
				dc_detail_item1_detail:
					"ฟังค์ชันสวัสดิการด้านการเงินเพื่อพนักงานโดยเฉพาะ โดยจำนวนเงินสำหรับการเบิกจะสะสมทุกวันที่พนักงานมาทำงาน*",
				dc_detail_item2_header: "วางแผนค่าใช้จ่าย",
				dc_detail_item2_detail:
					"ส่วนเสริมในการสร้างวินัยทางการเงินให้พนักงาน ฟังค์ชันบริหารจัดการค่าใช้จ่าย ทั้งยังสามารถตั้งค่าค่าใช้จ่ายประจำเดือนได้",
				dc_detail_remark_star:
					"*สงวนสิทธิสำหรับพนักงานของบริษัทที่เซ็นสัญญาใช้บริการ DAYCASH เท่านั้น",

				dc_benefit_title: "ประโยชน์ที่จะได้รับ",
				dc_benefit_teaser:
					"ตัวช่วยบริหารจัดการ รายรับ-รายจ่าย และเบิกเงินเดือนล่วงหน้าสำหรับค่าใช้จ่ายฉุกเฉิน",
				dc_benefit_item1_header: "DAYCASH เพื่อพนักงาน",
				dc_benefit_item1_detail1: "บริหารจัดการเงินเดือน",
				dc_benefit_item1_detail2: "ตัวช่วยในการควบคุมการใช้จ่าย",
				dc_benefit_item1_detail3: "เบิกเงินเดือนล่วงหน้าได้ผ่านแอปพลิเคชัน",
				dc_benefit_item1_detail4: "ปลอดภัยเทียบเท่ามาตราฐานธนาคาร",

				dc_feature_title: "คุณลักษณะเด่น",
				dc_feature_menu1: "บันทึกรายรับ - รายจ่าย",
				dc_feature_menu2: "แยกประเภทค่าใช้จ่าย",
				dc_feature_menu3: "กำหนดค่าใช้จ่ายล่วงหน้า",
				dc_feature_menu4: "เบิกเงินเดือนล่วงหน้า",

				thx_message: "ส่งข้อมูลเรียบร้อยแล้ว",
				thx_reply: "กรุณารอการติดต่อกลับจากทีมงาน",
				thx_back: "กลับหน้าหลัก",

				dc_benefit_item2_header: "DAYCASH เพื่อองค์กร",
				dc_benefit_item2_detail1: "สร้างวินัยด้านบริหารจัดการและการออมเงิน",
				dc_benefit_item2_detail2: "แบ่งเบาภาระในการจัดหาเงินทุนสำรองจ่าย",
				dc_benefit_item2_detail3: "ลดภาระการจัดการสวัสดิการด้านการเงิน",
				dc_benefit_item2_detail4: "สร้างภาพลักษณ์องค์กรใส่ใจพนักงาน",
				dc_benefit_item2_detail5: "เสริมสร้างความผูกพันต่อองค์กร",
				interestedProduct: "สนใจใช้งาน DAYCASH",
				interestedProduct2: "หรือต้องการความช่วยเหลือใดจากเรา",
				interestedProductSub:
					"โปรดบอกรายละเอียดเรื่องที่ต้องการติดต่อให้เราทราบ และทีมงานจะติดต่อกลับโดยเร็ว",
				onMissionTitle: "ภารกิจของเรา",
				onMission:
					"พัฒนาเทคโนโลยีแพลตฟอร์ม เพื่อช่วยแก้ปัญหาและพัฒนา กระแสเงินสดของบริษัทพาร์ทเนอร์และพนักงาน ที่มีประสิทธิภาพมากที่สุดในเอเชียตะวันออกเฉียงใต้",
				missionText1: `ที่ “มันนี่เทเบิล" เราเชื่อว่า การให้บริการเงินทุนสำหรับผู้บริโภค ไม่ควรจำกัดอยู่แค่พนักงานบริษัท แต่พนักงานระดับบริการต่างๆ ควรได้รับสิทธิ์นั้น เช่นกัน`,
				missionText2:
					"พนักงานระดับบริการ ควรมีโอกาสสำหรับการมีกระแสเงินสดที่ดี มีตัวเลือกทางการเงิน และการกู้ยืมที่มากขึ้น และมีความรู้ทางการเงินที่มากเพียงพอ  เพื่อสร้างอนาคตที่ดี เตรียมพร้อมรับวัยเกษียณ",
				missionText3: `บริษัทผู้ว่าจ้างพนักงานเหล่านี้ เป็นส่วนสำคัญของชีวิตพนักงานกลุ่มดังกล่าว และเรา “มันนี่เทเบิล” กำลังร่วมมือกับพวกเขา เพื่อพัฒนาชีวิตของพนักงานร่วมกัน`,
				missionText4: `ปัจจุบัน เรากำลังพัฒนาผลิตภัณฑ์ “DAYCASH” ผลิตภัณฑ์ที่จะเป็นทางออกแรก สำหรับการสร้างกระแสเงินสดที่ดีของพนักงาน เริ่มต้นจากเงินเดือนของพนักงานเอง ภายใต้คอนเซป “ให้ทุกวันเป็นวันเงินเดือนออก”`,
				goToDayCash: "รู้จัก DAYCASH เพิ่มเติม",
				awarded: "รางวัลที่ได้รับ",
				award2016: "2559",
				"award2016-content1":
					"ได้รับการสนับสนุน และเงินทุนจาก คุณชัชวาลย์ เจียรวนนท์",
				"award2016-content2":
					"ระดมทุน และได้รับเงินทุน รวมกว่า 200 ล้านบาท จาก 4 แหล่งทุน ดังต่อไปนี้",
				"award2016-content3": "Financia Syrus Securities PCL",
				"award2016-content4": "Asia Insurance 1950  PCL",
				"award2016-content5": "K2 Venture Capital",
				"award2016-content6": "Kejora Thailand",
				"award2016-content7": `ชนะรางวัล “Rising Star Award” ในงาน “C3 Finance From Thailand Fintech Challenge”`,
				award2017: "2560",
				"award2017-content":
					"แปรสภาพเป็น “บริษัท จำกัด (มหาชน)”    เมื่อวันที่ 15 กุมภาพันธ์ 2560",
				award2018: "2561",
				"award2018-content": "จับมือเป็นพันธมิตรกับ Microsoft Thailand",
				customer: "บริษัทพาร์ทเนอร์ ผู้ส่งเสริมสวัสดิการพัฒนาชีวิตพนักงาน",
				ourLeader: "ทีมงานของเรา",
				beam_pos: "ผู้ก่อตั้ง และรองประธานกรรมการบริษัท",
				chat_name: "ชัชวาลย์ เจียรวนนท์",
				chat_pos: "ประธานกรรมการบริษัท",
				soon_name: "ซูน ชัว",
				soon_pos: "ประธานเจ้าหน้าที่บริหาร",
				athi_name: "อธิ พิสุทธิพันธ์",
				athi_pos: "ประธานเจ้าหน้าที่สายผลิตภัณฑ์",
				patrick_name: "แพทริค ภคนันท์",
				patrick_pos: "ประธานเจ้าหน้าที่สายเทคโนโลยี",
				jib_name: "ธันยพร สำราญเกษ",
				jib_pos: "หัวหน้าฝ่ายพัฒนาผลิตภัณฑ์",
				nade_name: "ธเนศ จันทะโชโต",
				nade_pos: "หัวหน้าฝ่ายปฏิบัติการ",
				vee_name: "วีรินทร์ภัทร ฟูวังหม้อ",
				vee_pos: "ผู้จัดการฝ่ายคู่ค้าสัมพันธ์",
				nakrop_name: "นักรบ ภู่ทอง",
				nakrop_pos: "ผู้จัดการฝ่ายคู่ค้าสัมพันธ์",
				interestWork: "สนใจร่วมงานกับเรา?",
				jointeam: "สนใจร่วมงานกับเรา?",

				homepage_hero_title1: "พนักงานกำลังมีปัญหา",
				homepage_hero_title2: "เงินไม่พอใช้ระหว่างเดือน อยู่หรือไม่?",
				homepage_hero_title3:
					"มาช่วยให้พนักงานของคุณ มีสวัสดิการ เพิ่มสภาพคล่องทางการเงิน เพื่อชีวิตที่ดีขึ้น",
				gotoknow_dc: "สมัครใช้บริการ DAYCASH",
				homepage_about_title:
					"บริการที่ช่วยพนักงานแก้ปัญหา และจัดการกระแสเงินสด",
				homepage_about_desc: `DAYCASH แอปพลิเคชันที่ช่วยให้พนักงานเข้าถึงเงินเดือน
          ได้ในช่วงก่อนวันเงินเดือนออก ช่วยเพิ่มสภาพคล่องทางการเงิน 
          และบริหารจัดการกระแสเงินสดส่วนตัวในแต่ละเดือน`,
				homepage_about_btn1: "อยากรู้จัก DAYCASH เพิ่มเติม",
				homepage_about_btn2: "ติดต่อดูตัวอย่าง Demo",
				homepage_about_link: "เกี่ยวกับ MONEYTABLE",
				lacking_cashflow1: `“ค่าใช้จ่ายเยอะ แต่เงินเดือนยังไม่ออก ต้องเป็นหนี้ทบดอกเบี้ย หาใช้คืนวนไป” `,
				lacking_cashflow2: `อย่าปล่อยปัญหานี้สะสม จนรบกวนการทำงาน ชีวิต และอนาคตของพนักงานเลย!`,
				help_title: `เราอยู่นี่แล้ว
        พร้อมที่จะช่วยให้พนักงานนำ “เงินเดือน” ไปใช้ได้ทันท่วงที!`,
				help_cashflow_title: `เมื่อบริษัทมี DAYCASH เป็นสวัสดิการ ช่วยให้ “พนักงาน" มีสภาพคล่องทางการเงินที่ดีขึ้น`,
				help_topic_title1: `พนักงานสามารถเข้าถึงเงินเดือน
          ของวันที่ทำงานไปแล้วได้ทันที 
          ผ่านแอปพลิเคชัน DAYCASH
          `,
				help_topic_title2: "รับมือสถานการณ์ใช้เงินเร่งด่วน",
				help_topic_title3: "ลดความขัดแย้งระหว่างเพื่อนร่วมงาน",
				help_topic_title4: "สู่อิสรภาพทางการเงิน",
				help_topic_title5: "เบิกเงินล่วงหน้า ไม่มีค่าดอกเบี้ย",
				help_topic_desc1: `การเข้าถึงเงินเดือนที่พนักงานควรได้รับ เร็วขึ้นแม้เพียงหนึ่งวัน 
          ก็อาจจะสามารถช่วยเหลือ หรือช่วยให้เขาหลีกเลี่ยงเหตุการณ์
          ไม่พึงประสงค์ รวมถึง การกู้หนี้ ยืมสิน ซึ่งส่งผลในทางลบต่อชีวิต
          ในระยะยาว ได้ดีทีเดียว`,
				help_topic_desc1_1: "",
				help_topic_desc2:
					"หยุดกังวลว่าเงินจะเพียงพอต่อการใช้ชีวิตหรือไม่ หากพนักงานมาทำงาน เขาจะได้รับเงินสำหรับใช้ในวันถัดไป",
				help_topic_desc3:
					"จะไม่มีการยืมเงินในที่ทำงานกันอีกต่อไป ช่วยยุติปัญหาที่จะเกิดขึ้นตามมามากมาย เช่น การตกเป็นเบี้ยล่าง เนื่องจากสถานะการเป็นลูกหนี้  ซึ่งส่งผลต่อการทำงาน",
				help_topic_desc4:
					"เมื่อพนักงานรู้ว่าจะได้รับค่าจ้างต่อวันเท่าไหร่ เขาจะสามารถวางแผนจัดการเงินของตัวเองได้ง่ายมากขึ้น ลดการเกิดหนี้ สร้างเครดิตที่ดี สู่อนาคตที่มีอิสรภาพทางการเงิน",
				help_topic_desc5:
					"บริการเบิกเงินล่วงหน้า ไม่มีค่าดอกเบี้ย ไม่ทำให้การเบิกใช้เงินล่วงหน้าบานปลาย จนจ่ายไม่ไหว",
				pic_employee: "สำหรับพนักงาน",
				pic_employer: "สำหรับบริษัท",

				steps_title:
					"พนักงานสามารถเบิกเงินอย่างรวดเร็ว เพียง 4 ขั้นตอนใช้งานง่ายๆ",
				steps_title1:
					"เช็คอินเข้าทำงานเพื่อเพิ่มค่าจ้างของวัน เข้ากระเป๋าเงินในระบบClock-In at workplace (or in-app)",
				steps_title2: "ตรวจสอบจำนวนเงินที่สามารถเบิกถอนได้ บนแอป DAYCASH",
				steps_title3: "ทำรายการขอเบิกถอนในแอป และรอ HR อนุมัติ",
				steps_title4: "รับเงินผ่านช่องทางบัญชีธนาคารของพนักงาน",

				provide_cashflow_title: `DAYCASH ยังช่วยให้ “บริษัท" มีสภาพคล่องทางการเงินที่ดีขึ้น เช่นกัน`,
				provide_cashflow_title1:
					"บริษัทสามารถมีสวัสดิการช่วยเหลือด้านการเงินให้พนักงาน โดยไม่เป็นภาระกระแสเงินสดของบริษัท",
				provide_cashflow_title2: "ไม่ต้องถือเงินระหว่างเดือน เพื่อรอเบิก",
				provide_cashflow_title3:
					"สร้างแรงขับเคลื่อนให้เกิดการทำงานที่มีประสิทธิภาพ",
				provide_cashflow_title4: "ดึงดูดและรักษาพนักงาน",
				provide_cashflow_title5: "ทำให้งาน HR มีประสิทธิภาพมากขึ้น",
				provide_cashflow_desc1:
					"บริษัทสามารถมีสวัสดิการเบิกเงินเดือนล่วงหน้าให้พนักงาน โดยไม่จำเป็นต้องจำกัดงบประมาณเพื่อสวัสดิการนี้เลย เพียงพนักงานเบิกเงินเดือนล่วงหน้าผ่าน Day Cash",
				provide_cashflow_desc1_1: "",
				provide_cashflow_desc2:
					"บริษัทไม่ต้องกันงบประมาณส่วนหนึ่ง เพื่อไว้ให้พนักงานเบิกถอนระหว่างเดือนอีกต่อไป เพิ่มกระแสเงินสดไว้ใช้จ่ายกับธุรกิจได้อย่างคล่องตัว",
				provide_cashflow_desc3:
					"เมื่อพนักงานมีสวัสดิการทางการเงินที่ดี ทำให้มีพื้นฐานชีวิตที่ดีขึ้น และปัญหาส่วนตัวที่น้อยลง ส่งผลให้เกิดประสิทธิภาพการทำงานที่ดีมากขึ้นในแต่ละวัน",
				provide_cashflow_desc4:
					"จากข้อมูลผู้ใช้งานพบว่า บริษัทที่มีสวัสดิการทางการเงินให้พนักงาน มีแนวโน้มดึงดูดพนักงานมากขึ้นถึง 2 เท่า และสามารถลดอัตราการสูญเสียพนักงานได้ถึง 41%",
				provide_cashflow_desc5:
					"เมื่อพนักงานทำงานอย่างมีประสิทธิภาพมากขึ้น การขาดลามาสายและปัญหาในที่ทำงานน้อยลง ส่งผลให้ตัวชี้วัดต่างๆ ซึ่งเป็นผลลัพธ์งานบริหารบุคลากรของ HR ดำเนินไปในทางที่ดีขึ้น",
				emp_step_title:
					"บริษัทมี 3 ขั้นตอน ที่จะช่วยทำให้พนักงานของคุณสามารถเบิกเงินใช้ล่วงหน้าได้",
				emp_step_title1: "ทำการอนุมัติรายการขอเบิกถอนเงินของพนักงาน",
				emp_step_title2:
					"ได้รับ report แจ้งจำนวนเงินทั้งหมดที่พนักงานขอเบิกถอนไปในรอบตัดบิลนั้น",
				emp_step_title3: "ทำการโอนเงินคืนบริษัท Moneytable",
				emp_step_sub1: "ทุกวัน",
				emp_step_sub2: "ทุกวันตัดรอบบิล (cut-off)",
				emp_step_sub3: "ทุกรอบการจ่าย (pay date)",
				money_liter_title: "บทความ และกิจกรรม ส่งเสริมพัฒนาความรู้ทางการเงิน",
				partner_title1: "กว่า 200 บริษัท ร่วมสมัครและใช้ DAYCASH",
				partner_title2:
					"ทำให้พนักงานกว่า 100,000 คน มีชีวิตที่ดีขึ้น ด้วยกระแสเงินสดที่ดีขึ้น",
				partner_hero1: "การได้รับ“สวัสดิการทางการเงิน” ที่ดีขึ้น",
				partner_hero2: "ทำให้เกิด “ประสิทธิภาพการทำงาน” ที่ดีขึ้น",
				partner_hero3: "ส่งผลให้ “ชีวิตพนักงาน” ดีขึ้นในทุกวัน",
				partner_hero4: "— การบริหารจัดการทรัพยากรมนุษย์ (HR)",
				DC_program_title1:
					"บริการ DAYCASH และโครงการส่งเสริมความรู้ทางการจัดการการเงิน",
				DC_program_title2:
					"จำกัดให้เฉพาะ “พนักงานของบริษัท ที่เป็นพาร์ทเนอร์ บริษัท MONEYTABLE” เท่านั้น",
				DC_program_desc:
					"หากคุณเป็นพนักงาน และไม่ทราบว่าบริษัทของคุณเป็นพาร์ทเนอร์ของเราหรือไม่ กรุณากรอกแบบสอบถาม และทีมงานจะติดต่อกลับ",
				req_demo: "ติดต่อขอ DAYCASH Demo",

				usecase: "ประโยชน์สำหรับพนักงาน",
				usecase1: "เพิ่มสภาพคล่องทางการเงินจากการบริหารเงินเดือน",
				usecase2: "สวัสดิการทางการเงินสำหรับพนักงาน",
				usecase3: "หลีกเลี่ยงการกู้ยืมหนี้นอกระบบ",
				usecase4: "ลดภาระหนี้สิน",
				usecase5: "เพิ่มเครดิตทางการเงิน",
				saleandsup: "งานขายและฝ่ายบริการลูกค้า",
				contactMT: "ติดต่อเรา",

				//PRODUCT PAGE

				productHeroTitle1: "เข้าถึงเงินเดือนได้วันนี้!",
				productHeroTitle2:
					"สะสมเงินในแต่ละวันทำงานของคุณ และเบิกจ่ายได้รวดเร็วในยามจำเป็น",
				productHeroDesc1:
					"DAYCASH  คือแอปพลิเคชัน ที่จะช่วยให้พนักงานเบิกค่าจ้างได้ ในช่วงก่อนวันเงินเดือนออก เพิ่มสภาพคล่องทางการเงินให้แก่พนักงานและบริษัท",
				productHeroButton: "สมัคร DAYCASH วันนี้",
				productHeroCaption1: "เก็บเงินในแต่ละวันทำงานของคุณ",
				productHeroCaption2: "และเบิกจ่ายได้รวดเร็วในยามจำเป็น",
				productHeroFeature: "ด้วยฟีเจอร์ของ DAYCASH",
				productHelpTitle:
					"ร่วมกันสนับสนุนพนักงานให้มีกระแสเงินสดที่ดีขึ้น และสร้างเครดิตทางการเงิน ด้วย DAYCASH",
				productHelpDesc: `รู้หรือไม่!? พนักงานที่มีปัญหาขาดสภาพคล่องทางการเงิน ต้องกู้หนี้ยืมสินจากแหล่งเงินต่างๆ 
          มักจะสร้างปัญหาให้กับบริษัทในเวลาต่อมา แต่ในฐานะบริษัทผู้จ้างงาน 
          คุณสามารถช่วยเหลือพนักงาน และป้องกันไม่ให้เกิดปัญหาต่างๆ ได้`,
				productHelpButton: "ช่วยพนักงานด้วย DAYCASH",
				productFeature1: "สะสมเงิน",
				productFeature1_1: "ทุกวันทำงาน",
				productFeature2: "ขอเบิกถอนได้",
				productFeature2_1: "ทุกเมื่อที่ต้องการ",
				productFeature3: "โอนเงินรวดเร็ว",
				productFeature3_1: "ผ่านบัญชีส่วนตัว",
				productFeature4: "รายงานประจำเดือน",
				productFeature4_1: "สำหรับบริษัท",
				usecaseTitle: "สิ่งที่พนักงานจะได้รับ เมื่อใช้ DAYCASH",
				usecaseTitle1: "เพิ่มสภาพคล่องทางการเงินจากการบริหารเงินเดือน",
				usecaseDesc1:
					"Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged.",
				usecaseTitle2: "สวัสดิการทางการเงินสำหรับพนักงาน",
				usecaseDesc2: "Employee Benefits",
				usecaseTitle3: "หลีกเลี่ยงการกู้ยืมหนี้นอกระบบ",
				usecaseDesc3: "Avoid Shark Loans",
				usecaseTitle4: "ลดภาระหนี้สิน",
				usecaseDesc4: "Decrease Debt",
				usecaseTitle5: "เพิ่มเครดิตทางการเงิน",
				usecaseDesc5: "Personal Credits",
				usecaseTermHeaderTitle:
					"ในระยะยาวกับ DAYCASH อนาคตที่สดใสกำลังรอพวกเขาอยู่",
				usecaseTermHeaderDesc:
					"DAYCASH จะช่วยแนะนำพนักงานให้มีความสามารถในการจัดการด้านการเงินที่ดีขึ้น โดยอ้างอิงจากข้อมูลพฤติกรรมการเบิกค่าจ้างของพนักงาน",
				usecaseTermItem1: "หนี้ลดลง",
				usecaseTermItem1_1: "ความเครียดก็ลดลง",
				usecaseTermItem2: "ลาก่อนหนี้นอกระบบ",
				usecaseTermItem2_1: "ดอกเบี้ยบานปลาย",
				usecaseTermItem3: "กระแสเงินสดที่ดีขึ้น",
				usecaseTermItem3_1: "มาพร้อมวินัยการเงินที่ดีขึ้น",
				usecaseTermItem4: "มีเครดิตที่ดี",
				usecaseTermItem4_1: "สำหรับแผนการใช้จ่ายในอนาคต",
				benefitTitleNum1: "",
				benefitTitleNum2: "",
				benefitTitle1: "มีแรงจูงใจมาทำงานมากขึ้น",
				benefitTitle2: "ในพนักงานกว่า 73%",
				benefitTitle3: "ลดอัตราการลาออก",
				benefitTitle4: "ของพนักงานได้กว่า 41%",
				freeTitle1: "DAYCASH",
				freeTitle2: "บริการฟรี สำหรับบริษัทพาร์ทเนอร์",
				freeDesc1: "พร้อมสนับสนุนบริษัท และพนักงานของคุณ วันนี้!",
				freeDesc2: "บอกเราได้เลย ว่าเราสามารถช่วยเหลือคุณอย่างไรบ้าง",
				customerVoice: "เสียงจากผู้ใช้งาน",
				// End of Thai Section
			},
		},
		en: {
			translations: {
				"Available on": "Available on",
				btnheader: "Register HRTable with Promotion code",
				learn: "LEARN MORE",
				testdemo: "Contact Us",
				OR: "OR",
				"Copy Writer - Bangkok, Thailand": "Copy Writer - Bangkok, Thailand",
				"QA Officer - Bangkok, Thailand ": "QA Officer - Bangkok, Thailand ",
				"Business Development Executive - Bangkok, Thailand":
					"Business Development Executive - Bangkok, Thailand",
				"PR Manager - Bangkok, Thailand": "PR Manager - Bangkok, Thailand",
				"Community Marketing Manager - Bangkok, Thailand":
					"Community Marketing Manager - Bangkok, Thailand",
				"Content Marketing Manager - Bangkok, Thailand":
					"Content Marketing Manager - Bangkok, Thailand",
				"Full Stack Developer - Bangkok, Thailand":
					"Full Stack Developer - Bangkok, Thailand",
				"You are an independent problem solver and love to work in teams":
					"You are an independent problem solver and love to work in teams",
				"MoneyTable is Right for You if :": "MoneyTable is Right for You if :",
				"Great health benefits are available as well as business days off.":
					"Great health benefits are available as well as business days off.",
				"Expect frequent hours, work off-sites, pool table and table tennis tournaments. We play as hard as we work.":
					"Expect frequent   hours, work off-sites, pool table and table tennis tournaments. We play as hard as we work.",
				"Your next job should offer more than just free lunch, pool tables and happy hours. Reach your potential with a career at MoneyTable.":
					"Your next job should offer more than just free lunch, pool tables and happy hours. Reach your potential with a career at MoneyTable.",
				Careers: "Careers",
				"Automatic calculation": "Automatic tax calculation",
				product: "Product",
				"To get started, edit <1>src/App.js</1> and save to reload.":
					"To get started, edit <1>src/App.js</1> and save to reload.",
				"Welcome to React": "Welcome to React and react-i18next",
				Title: "Welcome to {param}",
				awarded: "AWARDED",
				moneytable: "MoneyTable",
				contactus: "Contact Us",
				hero1: "SMART PLATFORM",
				"hero1.5": "FOR YOUR SMART WORKPLACE",
				hero2:
					"Our HR software & benefit offerings help employers save time and money, so they can focus on growing their business.",
				hero3:
					"Our benefits allow employees financial peace of mind, so they can do more of what they love.",
				hero_product: "Our Products",
				"newupdate-title": "News Update",
				"newupdate-title-all": "More",
				"ourproduct-title": "Our Platform",
				hrtable: "HRTable",
				"SOLUTIONS THAT WILL SUPER CHARGE YOUR COMPANY":
					"SOLUTIONS THAT WILL SUPER CHARGE YOUR COMPANY",
				MONEYTABLE: "MONEYTABLE",
				"A Simple, Fast and Reliable Employee Benefit":
					"A Simple, Fast and Reliable Employee Benefit",
				detail1:
					"MoneyTable gives employees a good additional benefit and reduces their financial stress. And allows employees to borrow directly from trusted financial institutions at competitive rates. Their debt is repaid directly through our automatic credit collection process. With no setup fees and no hidden cost, we create a win-win for everyone. Request a Demo Today",
				HRTABLE: "HRTABLE",
				"A Simple, Fast and Reliable People Operating Platform":
					"A Simple, Fast and Reliable People Operating Platform",
				detail2:
					"HRTable is a Digital HR Platform. Its powerful HR tools will save hours of paperwork and allow businesses to focus on what’s important, the employees. Upgrading a company has never been faster or easier than with HRTable.",
				detail3:
					"MoneyTable is a good benefit through which Employers can offer their employees fast and affordable liquidity. With value added for both the employer and employee, MoneyTable is the perfect solution to the money worries of your employees.",
				"Employer’s Value": "Employer’s Value",
				"Employees’s Value": "Employees’s Value",
				detail4:
					"Employers can take pressure off their employees and increase the productivity of the company by offering a new benefit at no cost or risk. With MoneyTable employees can get easy and fast access to low rate loans with near 100% approval rates.",
				detail5:
					"With MoneyTable employees can get easy and fast access to low rate loans with near 100% approval rates. This means no more going to the bank, no more rejection* and no more money worries.",
				"Easy & Fast Access to loans": "Easy & Fast Access to loans",
				"Competitive Rates": "Competitive Rates",
				"Near 100% Approvals": "Near 100% Approvals",
				"Reduces Employee Debt Burden": "Reduces Employee Debt Burden",
				"No More Bank Visits": "No More Bank Visits",
				"No Rejection*": "No Rejection*",
				"No More High Interest": "No More High Interest",
				"No More Money Worries": "No More Money Worries",
				"* We have low rejection rates": "* We have low rejection rates",
				detail6:
					"Our powerful HR tools will save hours of paperwork and allows companies to focus on what’s important – their employees. With value designed for both the employer and employee, HRTable is the perfect solution for HR problems and for making businesses more efficient.",
				detail7:
					"Employers can manage their employees with one free and easy to use HR EcoSystem. With features like automatic payroll & tax calculation and GPS Clock-in and Clock-out; HRTable takes companies to the next level.",
				detail8:
					"HRTable comes with a Mobile App that is equipped with handy self-service features such as clock in-out, leave and holiday requests, expense claims and report generation. Gone are the days of emailing, texting, calling or walking to the HR department.",
				"Automatic payroll calculation": "Automatic payroll calculation",
				"GPS Clock-in and Clock-out": "GPS Clock-in and Clock-out",
				"Company announcements": "Company announcements",
				"And many more features…": "And many more features…",
				"WITH MONEYTABLE PLC, YOU’RE IN GOOD COMPANY":
					"WITH MONEYTABLE PLC, YOU’RE IN GOOD COMPANY",
				detail9:
					"We are helping 1,000 companies all over Thailand with our amazing products. Contact us today and learn how we can help your company.",
				"More than 100,000 Employee’s Can’t be Wrong":
					"More than 1,000 Employee’s join with us",
				detail10:
					"We have helped over 100,000 employees this year alone and hundreds more are signing up every day; view the testimonials and see for yourself how happy our customers are.",
				detail11:
					"With our private data cloud, bank approved security standards and our digital eco-system we can safeguard sensitive information - your HR Data is in good hands.",
				"Our Security and Technology is Second to None":
					"Our Security and Technology is Second to None",
				"Private Data Cloud with Bank Approved Security":
					"Private Data Cloud with Bank Approved Security",
				"128 Bit Encryption Ensures that Data is Safe":
					"128 Bit Encryption Ensures that Data is Safe",
				"Our EcoSystem Allows Businesses to Manage Their Employees Smoothly 24/7 - 365":
					"Our EcoSystem Allows Businesses to Manage Their Employees Smoothly 24/7 - 365",
				detail12:
					"We will show you exactly how our HR Software can take your business to the next level and good benefit can erase your employees money worries.",
				common1: "WITH MONEYTABLE PLC, YOU’RE IN GOOD COMPANY",
				Wearehelping: "We are helping",
				"1000companies": "1,000 companies",
				"employee2-title": "Testimonial",
				employee2: "More than 4,000 companies using our products",
				"employee2-1":
					"Over 100,000 employees using our HR Program and 10,000 more using our Loan Application and still signing up every day; view the testimonials and see for yourself how happy our customers are.",
				employeelist: "Our Clients",
				common2:
					"all over Thailand with our amazing products. Contact us today and learn how we can help your company.",
				common3: "More than 1,000 Employee’s join with us",
				common4:
					"We have helped over 3,000 employees this year alone and hundreds more are signing up every day; view the testimonials and see for yourself how happy our customers are.",
				common5: "Our Security and Technology is Second to None",
				common6:
					"With our private data cloud, bank approved security standards and our digital eco-system we can safeguard sensitive information - your HR Data is in good hands.",
				common7: "Private Data Cloud with Bank Approved Security",
				common8: "128 Bit Encryption Ensures that Data is Safe",
				common9:
					"Our EcoSystem Allows Businesses to Manage Their Employees Smoothly 24/7 - 365",
				common10: "Contact Us Now & Request a Demo",
				common11:
					"We will show you exactly how our HR Software can take your business to the next level and good benefit can erase your employees money worries.",
				common12: "Contact us via Line",
				MoneyTable: "MoneyTable",
				"A Free Benfit for your Employees": "A Good Benfit for your Employees",
				// "1000companies":"At no cost and easy set-up, employees can enjoy a free benefit to increase their financial welfare. The user-friendly application allows employees to obtain affordable loans, which will increase their productivity and happiness.",
				// "detail1":"At no cost and easy set-up, employees can enjoy a free benefit to increase their financial welfare. The user-friendly application allows employees to obtain affordable loans, which will increase their productivity and happiness.",
				business: "HOW WE CAN HELP YOUR BUSINESS",
				"MoneyTable solves your employees money worrys and allows you to focus on your business":
					"MoneyTable solves your employees money worries and let you to focus on your business.",
				"Leding the easy way": "Lending the easy way",
				"With MoneyTable as a free benefit for your employees":
					"With MoneyTable as a good benefit for your employees, your company can connect employees to a trusted loan source. Employees repay their loans directly through our automatic credit collection process and access all the information they need directly from the MoneyTable Mobile App – lending has never been easier or faster.",
				"Low Rates, High Approvals": "Low Rates, High Approvals",
				"With our loan providers almost all loans can be approved for your employees":
					"With our loan providers ,almost at all loans could be approved for your employees. With our low rates, your employees will get some of the best loan offers in Thailand.",
				"YOUR EMPLOYEES’ FINANCIAL WELLBEING MATTERS":
					"YOUR EMPLOYEES’ FINANCIAL WELLBEING MATTERS",
				"Money Worries Result in Lower Employee Productivity":
					"Money Worries Result in Lower Employee Productivity",
				"Over half of employers worry about their employees":
					"Over half of employers worry about their employees’ financial health, and 90% of employers agree that financial concerns have an impact on employees’ work performance. However, employers do not always have the resources to help. With MoneyTable, employees’ money worries are a thing of the past. MoneyTable is a win-win for everyone. Increase employee productivity and morale, contact us today.",
				"WHY USE MONEYTABLE?": "WHY USE MONEYTABLE?",
				"Free Platform": "Free Platform",
				"MoneyTable wants to enhance the welfare of Employees and help employers":
					"MoneyTable wants to enhance the welfare of Employees and help employers, thus our platform and simple integration process is for free.",
				"Easy Loans": "Easy Loans",
				"Our loans see almost 100% approval rates so your employees":
					"Our loans  almost 100% approval And also low rates so your employees can always get the money they need.",
				"Fast Access to Funds": "Fast Access to Funds",
				"With our state of the art App and easy user interface":
					"With our application is easy user interface, employees can apply for a loan faster than ever before.",
				"Affordable Rates": "Affordable Rates",
				"We have negotiated some of the best rates available in the market":
					"We have negotiated some of the best rates available in the market, to give employees the opportunity to manage their finances.",
				"Easy Loan Repayment": "Easy Loan Repayment",
				"Loans are paid back directly through MoneyTable":
					"Loans are paid back directly through MoneyTable’s proprietary automated credit collection process - debt collection is now a thing of the past.",
				"Trusted Sources": "Trusted Sources",
				"We partner with leading Banks and Financial institutions":
					"We partner with leading Banks and Financial institutions, to make sure your employees receive the money they need.",
				"Increase Productivity": "Increase Productivity",
				"With employee money worries gone":
					"With employee money worries gone, everyone can focus on the business at hand.",
				"Customer Service": "Customer Service",
				"Our caring customer service team":
					"Our caring customer service team will always answer your queries with a smile.",
				Retain: "Retain",
				"happy employees means less turn over":
					"happy employees means less turn over.",
				Attract: "Attract",
				"people are more likely to apply to jobs that have more benefits":
					"people are more likely to apply to jobs that have more benefits.",
				Motivate: "Motivate",
				"employees with more benefits are more likely to have higher motivation":
					"employees with more benefits are more likely to have higher motivation.",
				"HR TABLE": "HR TABLE",
				"Easy, Fast & Free": "Automated HR Management System",
				"People Operating Platform": "",
				"We provide a state of the art":
					"We create HR Management System for Smart Workplace to be Digital Organization",
				"MANAGE YOUR TEAM WITH": "Professional organizing Platform",
				"EASE, FOR FREE": "EASE, FOR FREE",
				"With Our Features Your Company":
					"With HRTABLE Features, you can manage HR work so easily and systematically",
				"Auto-Calculate Payroll": "Auto-Calculate Payroll",
				"Never calculate payroll again":
					"Saving time with Automatic calculate payroll , with a few clicks salaries will be distributed automatically.",
				"Automatic Payroll Calculation":
					"Automatic Payroll Calculation Seamless Salary Distribution with SCB or Upload Batch File for multiple banks",
				"E-Payslip for Employees": "E-Payslip for Employees",
				"Taxes Made Easy": "Automatic Taxes Calculation",
				"Comprehensive Tax Overview":
					"Taxes are Automatically Calculated by our features , easy and saving time.",
				"Automatic Tax Calculation for Employees and Company":
					"Automatic Tax Calculation for Employees and Company",
				"Provident Fund": "Provident Fund",
				"Investment Recommendations":
					"Investment Recommendations (LTF/RMF/Life Insurance) for Tax Saving Purposes (coming soon)",
				"Employee Database & Records": "Employee Database & Records",
				"Comprehensive Record Keeping of current and past Employees":
					"Intelligent search & discovery with professional organizing employee Database & Records.",
				"Employee Information Database": "Employee Information Database",
				"Organizational Chart": "Organizational Chart",
				"Company Announcements": "Company Announcements",
				"Keep you Employees Informed with the Latest Company Announcements":
					"The Company Announcements sent Directly to employees Mobile Devices",
				"Announce Company Events, Holidays and more":
					"Announce Company Events, Holidays and more",
				"Company Announcements through":
					"Company Announcements through Push-Notification (coming soon)",
				"Clock-In & Clock-Out Employee Self Service (ESS)":
					"Clock-In & Clock-Out Employee Self Service (ESS)",
				"Clock-In & Clock-Out Information is embedded in our HR-Platform so You Can Always Keep Track of Time":
					"Clock-In & Clock-Out Information is embedded in our HR-Platform so You Can Always Keep Track of Time",
				"GPS based Clock-In & Clock-Out": "GPS based Clock-In & Clock-Out",
				"Location-Selfie based Clock-In & Clock-Out":
					"Location-Selfie based Clock-In & Clock-Out",
				"Data Overview on the HR Dashboard":
					"Data Overview on the HR Dashboard",
				"Employee Self-Onboarding (ESS)": "Employee Self-Onboarding (ESS)",
				"HR saves time as Employees Directly Enter":
					"The employee can update any information by themselves on HRTABLE Platform that help HR to saving time ",
				"Customizable Data Fields": "Customizable Data Fields",
				"Employee Self-Onboarding": "Employee Self-Onboarding",
				"Employee Requests (ESS)": "Employee Requests (ESS)",
				"Employees are Able to Submit a Multitude":
					"Employees are able to submit a multitude of requests from their mobile device without to Submit Paperwork with HR",
				"Customizable Approval Process for the Employer with Multiple Steps":
					"Customizable Approval Process for the Employer with Multiple Steps",
				"Holiday Request": "Holiday Request",
				"Expense Request": "Expense Request",
				"Overtime Request": "Overtime Request",
				"Advance Cash Request for Business Purposes":
					"Advance Cash Request for Business Purposes",
				"Field Work Request with Remote Clock-In":
					"Field Work Request with Remote Clock-In",
				"Employee Referrals": "Employee Referrals",
				"Find the best Employees for your Company from your own Network":
					"Find the best Employees for your Company from your own Network",
				"Employees Share Job Vacancies on Social Media":
					"Employees Share Job Vacancies on Social Media",
				"Government Forms": "Government Forms",
				// "Employee Referrals":"Employee Referrals",
				"Payroll Payment Processing": "Payroll Payment Processing",
				"Manage All Your Branches":
					"The system has all government forms and always updated",
				"PND Form": "PND Form",
				"SSOs Form": "SSOs Form",
				Others: "Others",
				Other: "Other",
				"Auto payroll payment processing so, your accountant don’t have to go to bank anymore":
					"Auto payroll payment processing so, your accountant don’t have to go to bank anymore",
				"Support online transaction processing by leading banks in Thailand":
					"Support online transaction processing by leading banks in Thailand",
				"LET’S US HELP YOU": "LET’S US HELP YOU",
				"Send us your information, Our team will help you reach your goals":
					"Send us your information, Our team will help you reach your goals",

				"contact us": "contact us",
				"Give us you information": "Please let us know about you.",
				"Your Name": "Your Name",
				"Your number": "Your number",
				"Email Address": "Email Address",
				"Subject of the Email": "Subject of the Email",
				"Your Message": "Your Message",
				"Company name": "Company name",
				Address: "Address",
				District: "District",
				Amphur: "Amphur",
				Province: "Province",
				Zipcode: "Zipcode",
				Business: "Business",
				"Contact information": "Contact information",
				"Corporate Information": "Corporate Information",
				"Other information": "Other information",
				"Are you a Microsoft Office 365 customer?":
					"Are you a Microsoft Office 365 customer?",
				"No, but interested to use Microsoft Office 365.":
					"No, but interested to use Microsoft Office 365.",
				"Do not be and ignore Microsoft Office 365":
					"Do not be and ignore Microsoft Office 365.",
				"Yes, I do": "Yes, I do",
				"Employee number": "Employee number",
				Channel:
					"How do you know us (Eg. Website,Event,Advertising, Socialmedia)",
				email: "Email",
				line: "Line ID",
				tel: "Phone Number",
				other: "Social Media",
				about: "About Us",
				aboutus: "About Us",
				usecase: "Use Cases",
				usecase1: "Salary Cashflow Solution",
				usecase2: "Employee Benefits",
				usecase3: "Avoid Shark Loans",
				usecase4: "Decrease Debt",
				usecase5: "Increase Personal Credit",

				Financial_Policy: "Financial Policy",
				"Select one": "Select one",
				Welcome: "Welcome",
				"Somthing went wrong": "Somthing went wrong!",
				"Subscription requires a promotional code.":
					"Subscription requires a promotional code.",
				"Do you have a promo code?": "Do you have a promo code?",
				"Request a promotional code": "Request a promotional code",
				"I already have a promo code.": "I already have a promo code.",
				term: "Term & Conditions",
				privacy: "Privacy",
				Social: "Social Network",
				Request: "Request a Demo Today",
				Contact: "Contact Us",
				Learn: "Learn More",
				Sendus: "Send us an email",
				Let: "Let Us Call You",
				Log: "Log in",
				Read: "Read the MoneyTable Report",
				ContactUs: "Contact Us to Register",
				Requesta: "Request a Demo",
				Send: "Send",
				"Back to home": "Back to home",
				"Data has been successfully sent.": "Data has been successfully sent.",
				"Please wait for a response from us.":
					"Please wait for a response from us.",
				vision: "VISION",
				ourterm: "OUR TEAMS",
				ourLeader: "OUR LEADERSHIP",
				ourStory: "Our Story",
				"we are Moneytable": "We are Moneytable",
				about1: "Moneytable (Public) Co., Ltd.",
				about2: "was founded in 2016.",
				about3:
					"We are a HR and Financial Benefits Platform for Companies & their Employees.",
				onMission:
					"To build the most effective salary cash flow solution platform in Thailand and South East Asia for both employees and employers",
				onMissionTitle: "We’re on a MISSION",
				missionText1:
					"At Moneytable, we believe that consumer financing should not limited to banked working class, but also the under-banked. ",
				missionText2:
					"The under-banked working class should be able to have more flexible cashflow, more options on financing and loans, and more financial literacy to have the better future and retirement. Employer of the under-banked working class is the big part of their employee life. We are working with them to support their employee.",
				missionText3:
					"That’s why we create “DAYCASH” the THE COMPLETE SALARY CASHFLOW SOLUTION platform",
				missionText4:
					"We started from “MAKE EVERYDAY AS YOUR PAY DAY” to increase the liquidity of their cashflow",
				goToDayCash: "Go to DayCash",

				Fun: "Fun",
				"Food & Happy Hour": "Food & Happy Hour",
				"Health & Business": "Health & Business",
				Culture: "Culture",
				Training: "Training",
				"Work Off-Site": "Work Off-Site",
				"Expect frequent   hours, work off-sites, pool table and table tennis tournaments. We play as hard as we work.":
					"Expect frequent   hours, work off-sites, pool table and table tennis tournaments. We play as hard as we work.",
				"Lunch is delivered every day at noon, eatas much as your heart desires. Every Friday satisfy your sweet tooth with our end of the week treats.":
					"Lunch is delivered every day at noon, eatas much as your heart desires. Every Friday satisfy your sweet tooth with our end of the week treats.",
				"Evolve as a professional in a demanding but caring environment. We take pride in our commitment to teamwork - at MoneyTable you will always be part of a team that isstronger than the sum of its parts.":
					"Evolve as a professional in a demanding but caring environment. We take pride in our commitment to teamwork - at MoneyTable you will always be part of a team that isstronger than the sum of its parts.",
				"Training by leading tech icons and business leaders.":
					"Training by leading tech icons and business leaders.",
				"Take company retreats and work off-sites. In the past we took trip to Thai beach resorts and the Silicon Valley in California.":
					"Take company retreats and work off-sites. In the past we took trip to Thai beach resorts and the Silicon Valley in California.",
				"MoneyTable is Right for You if": "MoneyTable is Right for You if :",
				"You are motivated to help people reach financial security":
					"You are motivated to help people reach financial security",
				"You are smart, curious and self motivated":
					"You are smart, curious and self motivated",
				"You exercise good judgement and take responsibility for your work":
					"You exercise good judgement and take responsibility for your work",
				"Current Career Openings": "Current Career Openings",
				career_title: "Not just an employee, but we are a team.",
				APPLY: "APPLY",
				"contact-us-package": "Contact Us",
				tm_product: "Product",
				tm_productDC: "Day Cash Product",
				tm_aboutus: "Money Literacy",
				tm_blog: "Blogs",
				tm_contactus: "Contact MT",
				tm_activity: "Activities",
				hrnews: "HR News",
				finews: "Financial News",
				hero_mt: "Loan application that offer you financial liquidity",
				hero_mt_1: "for the better life of your employees.",
				hero_hr: "Digital HR Program that helps your HR works",
				hero_hr_1: "by increasing organization efficiency.",
				f_whovare: "Who we are?",
				f_whatvdo: "What we do?",
				f_ourvi: "Our Vision",
				f_awarded: "Awarded",
				f_ourmis: "Our Mission",
				f_coreval: "Core Value",
				f_ourtea: "Our team",
				f_jointeam: "Join our team",
				f_privac: "Privacy",
				f_parther: "Partners",
				f_blog: "Blogs",
				f_company: "Company",
				f_tips: "Tips",
				f_vocal: "Vocabulary",
				f_contact: "Fill form (other question)",
				f_contacthr: "Request for HRTable Demo",
				f_contactmt: "Request for MoneyTable Demo",
				f_condition: "Term & Conditions",
				hero_line1: "We create",
				hero_line2: "Innovative Digital Platform",
				hero_line3: "for SMART Workplace",
				f_association: "Association",
				f_financial: "Financial",
				f_software: "Software",
				f_insurance: "Insurance",
				interestedProduct: "INTERESTED IN OUR PRODUCT",
				interestedProduct2: "OR NEED ANY SUPPORT",
				interestedProductSub:
					"Please fill-in details in the form below, then our partnership team will support you soon as possible.",

				mt_detail1:
					"MoneyTable, Loan Application that facilitate the financial comfort of your employees.",
				mt_detail2:
					"It allows employees to borrow directly from trusted financial institutions at competitive rates. ",
				mt_detail3:
					"It brings joy to the work of both employees and business owners.",
				mt_detail4: "",
				hero_s2_line1: "Digital HR Platform",
				hero_s2_line2: "Automated Payroll Payment",
				hero_s2_line3: "reduce your work load",
				hero_s3_line1: "Digital HR Platform",
				hero_s3_line2: "Clock-in Clock-out through APP",
				hero_s3_line3: "via GPS & Finger scan",
				hero_s4_line1: "Digital HR Platform",
				hero_s4_line2: "that makes VDO Call via Skype",
				hero_s4_line3: "meeting everywhere, anytime",
				hero_s5_line1: "Digital HR Platform",
				hero_s5_line2: "on Cloud Base (Microsoft AZURE)",
				hero_s5_line3: "World Class Security System",
				hero_learnmore: "Learn more",
				"contact-us-package-detail":
					"Please complete your information. Our team will contact you soon.",
				"select-subject": "Choose your topic *",
				"more-infomation-mt": "More information - MoneyTable",
				"more-infomation-hr": "More information - HRTable",
				"trail-moneytable": "Request trial - MoneyTable",
				"trail-hrtable": "Request trial - HRTable",
				"select-other": "Others",
				"map-address": "142 Rama 9 Road., Huai Kwang Bangkok 10310",
				hot_deal: "HOT DEAL!",
				mission: "Mission",
				mission_1:
					"To develop ultimate eco-system product to fit all lifestyles",
				mission_2: "To deliver the most innovative financial technology",
				mission_3:
					"To create better experience and service for all users especially the unbanked",
				corevalue: "VALUE PROPOSITION",
				corevalue_1: "Trusted",
				corevalue_2: "Professional",
				corevalue_3: "Innovation",
				corevalue_4: "Simplicity",
				corevalue_5: "Decentralized",
				corevalue_6: "Can do attitude",
				"corevalue_1-1":
					"Empowering employees with salary cash flow when they need it",
				"corevalue_2-1":
					"Helping employees find alternatives to high interest loans",
				"corevalue_3-1":
					"Enabling employers to provide salary cash flow benefits to employees with risk and cost",
				"corevalue_4-1":
					"Allowing financial institutions to have market access to the large working class market segment in Thailand and South East Asia.",
				"corevalue_5-1":
					">> Reduce the steps (middleman) in the operation and create good results to business",
				"corevalue_6-1": ">> Work with commitment and positive attitude",

				award: "AWARDED",
				award2016: "2016",
				"award2016-content1": "Obtained funding from Mr.Chatchaval Jiaravanon",
				"award2016-content2":
					"4 Fund-raising capitals for a total 200 million THB",
				"award2016-content3":
					"Finansia Syrus Securities Public Company Limited",
				"award2016-content4": "Asia Insurance 1950 Public Company Limited",
				"award2016-content5": "K2 Venture Capital",
				"award2016-content6": "Kejora Thailand",
				"award2016-content7":
					"Won a Rising Star Award on behalf of C3 Finance from Thailand Fintech Challenge",
				award2017: "2017",
				"award2017-content":
					"Became to Public Limited Company (PLC) on 15 February 2017",
				award2018: "2018",
				"award2018-content": "Alliance with Microsoft Thailand",
				customer: "our customers",

				followus: "Follow us",
				testimonail_text: "Our stories",
				tm_testimonial: "Testimonial",
				beam_name: "TRIDBODI ARUNANONDCHAI",
				beam_pos: "Founder/Vice Chairman",
				chat_name: "CHATCHAVAL JIARAVANON",
				chat_pos: "Chairman",
				soon_name: "SOON CHUA",
				soon_pos: "CEO",
				athi_name: "ATHI PISUTHIPUN",
				athi_pos: "CPO",
				patrick_name: "PATRICK PAKANAN",
				patrick_pos: "CTO",
				jib_name: "THUNYAPORN SAMRANKASE",
				jib_pos: "HEAD OF PRODUCT",
				nade_name: "TANADE CHANDASHOTO",
				nade_pos: "HEAD OF OPERATION",
				vee_name: "VEERINPHAT FUWANGMOR",
				vee_pos: "PARTNERSHIP MANAGER",
				nakrop_name: "NAKROP PHUTHONG",
				nakrop_pos: "PARTNERSHIP MANAGER",
				interestWork: "INTERESTED IN WORKING WITH US?",
				jointeam: "JOIN OUR TEAM",

				beam_quote:
					"Serial entrepreneur in Digital Consumer, AI and Media with 10+ years of Banking experience.",
				don_name: "Piya Jootar",
				don_pos: "Chief Product Officer",
				don_quote: "18+ years of Enterprise Software and System Integration.",
				jim_name: "Kridchaya Komonsittivate",
				jim_pos: "Chief Operation Officer",
				jim_quote:
					"18+ years in System Integration, Business Process and Operation Management.",
				jon_name: "Nat Malasit",
				jon_pos: "Chief Technology Officer",
				jon_quote: "17+ years in HR Tech and Web App in Thailand and UK.",
				"jon_quote-1": "",
				pop_name: "Preedee Nukulsomprattana",
				pop_pos: "Chief Communication Officer",
				pop_quote:
					"14+ years in marketing & communications from government and private sector in property and automotive industry. Consultants, guest speaker & lecturer in marketing, communication and branding.",
				lookpad_name: "Siriwarch Sravich",
				lookpad_pos: "Head of Operation",
				lookpad_quote:
					"10 years for system implementation in various Software development business, such as Hotel & Tourism Industry, Human Resource Industry (HRM & HRD) and Airlines Industry.",

				patrick_quote:
					"12+ Years of Project and Product management. Experience in large multinational corporation and fast-growing startups.",
				tong_name: "Panaya Pengboon",
				tong_pos: "Product Owner (HR)",
				tong_quote:
					"8 years experience in develop IT product from large enterprise.",
				wut_name: "Wutthichai Insaeng",
				wut_pos: "Product Owner (HR)",
				wut_quote: "7+ years in develop web application.",
				"wut_quote-1": "",
				yod_name: "Pisan Ruechataveeroongroj",
				yod_pos: "Product Owner (Finance)",
				yod_quote:
					"16 years in international software development and project management.",
				andy_name: "Akaradej (Andy) Disyadej",
				andy_pos: "Head of Business Development",
				andy_quote:
					"30 years of experience including senior management role, strategic sales management, business development for the global financial services in Hong Kong, Singapore and Thailand cover SEA and Indochina markets. Understand the business complexity and managing sales in SEA and the Indochina markets LCMV.",
				contact_us_hrtable: "Please complete your information",
				contact_us_hrtable2: "for our team to contact you",
				contact_mt: "Contact MoneyTable product",
				contact_mt2:
					"Please complete your information, our product team will contact your soon.",
				contactus_now: "Contact us now",
				hot_deal_p1: "HOT DEAL!",
				hot_deal_p2: "",
				seeall_promotion: "See all promotions",
				seeall_promotion_more: "More information",
				viewmorestaff: "Our professionals",

				hrt_hero_1: "HR Management Program",
				hrt_hero_2: "for Digital Workplace",
				hrt_hero_3: "Environment",
				hero_btn_trial: "Request for demo Today",
				hero_btn_login: "Log in",
				hero_new_bottom: "ตอบโจทย์การทำงานกับ ฟีเจอร์หลัก",
				hero_new_bottom_feature_1:
					"ระบบคำนวณเงินเดือน | ระบบบันทึกเวลาเข้า - ออก | ระบบจัดการข้อมูลพนักงาน",
				btn_download_brochure: "Download brochure",
				hr_detail_title_desc: "Automated, Smart & Easy",
				หมดปัญหาเรื่องงานเอกสาร: "Say no to paper work",
				nt_001:
					"With digital management system you can reduce your paper work and increase your working speed",
				"ระบบอัตโนมัติแบบ Real-time": "Real-time automated system",
				nt_002:
					"Experience the digital 4.0 automated system. Real smart & easy at your fingertips",
				"ปลอดภัย ไร้กังวล": "Highest security",
				nt_003:
					"Ensure your data kept safe on cloud system with bank approved security standard",
				ระบบการทำงาน: "Features",
				nt_004: "Automated Payroll",
				nt_005:
					"Automatic calculate payroll from your personal financial record such as income, deduction, overtime, compensations. Employee can check e-payslip by your own via HRTable mobile application",
				btn_trial: "Request demo",
				nt_006: "Time Attendance",
				nt_007:
					"Manage your real-time clock-in, clock-out via GPS system, Finger Scan. Suitable for various kind of business",
				nt_008: "Employee Database Management",
				nt_009:
					"Manage your employee database and organization chart. Employee can manage your personal information by yourself through Employee Self-Service (ESS)",
				บริหารช่วงเวลาทำงาน: "Shift Management",
				nt_010:
					"Manage your different working time suitable for various kind of business",
				ส่งคำขอและอนุมัติการลา: "Request & Approval",
				nt_011:
					"Just few steps to submit your requests via mobile application such as Holiday Request, Expense Request, Overtime Request and Field Work Request",
				การสื่อสารในองค์กร: "Internal Communication",
				nt_012:
					"Increase communication efficiency towards organization through in-app announcement as well as VDO Call through Skype by Office365",
				สรรหาพนักงานใหม่: "Recruitment",
				nt_013:
					"Add/Share your job vacancy through system and post link on any website",
				ข้อมูลติดต่อภายในบริษัท: "Internal Directory",
				nt_014: "Create & contact your employee through mobile application",
				ไม่สนใจ: "Not interest",
				ดาวน์โหลดเอกสารจากหน่วยงานของรัฐ: "Government Forms",
				nt_015: "The system has all government forms and always updated",
				สอบถามข้อมูล: "More information",
				เพิ่มเติม: "",
				ติดต่อเราเพื่อขอทดลองใช้ระบบ: "Contact us for trial",

				mt_hero_1: "Loan application",
				mt_hero_2: "that helps your employees experience",
				mt_hero_3: "the trusted financial solution at low interest",
				nt_101: "Almost 100% approval rate at low interest",
				nt_102: "Apply for a loan faster than ever before via application.",
				nt_103: "From the lowest interest source of loan",
				nt_104:
					"Paid money back directly through MoneyTable’s proprietary automated credit collection process",
				เปอร์เซ็นต์ในการอนุมัติสูง: "High approval rate",
				เข้าถึงแหล่งสินเชื่อได้ง่าย: "Fast & easy access to source of loan",
				อัตราดอกเบี้ยที่เป็นธรรม: "Affordable interest rate",
				ระบบการจ่ายเงินคืนแสนสะดวก: "Easy Loan Repayment",
				mt_detail_title_desc: "Loan application for employee’s happiness",
				ทำไมต้องMONEYTABLE: "Why MONEYTABLE ?",
				สมัครง่าย: "Easy registration",
				อนุมัติไว: "Quick approval",
				รับเงินทันใจ: "Receive money",
				ได้ใจพนักงาน: "Employee loves you",
				nt_105: "Almost 100% approval rate at low interest",
				nt_106:
					"The most interesting loan offer for your employee, decrease your financial concern",
				nt_107: "Automatic Calculation",
				nt_108:
					"Employee can access to source of loan via our application. The reimbursement will be made automatically.",
				ติดต่อเราตอนนี้: "Contact us Now!",
				namtan_pos: "Head of Sale",
				namtan_name: "Chatravee Jaroensuk",
				namtan_quote:
					"6 years of experience in sales & marketing from SME & Startup business",
				pam_pos: "Managing Director",
				pam_name: "Nattinee Sirirattanapol",
				pam_quote:
					"Seasoned Entrepreneur & Experienced Banker with background in Treasury & Global Markets",

				dc_hero_1: "All in one financial welfare application",
				dc_hero_2: "for all employees: salary management",
				dc_hero_3: "and emergency expenses",
				dc_hero_contact: "Contact for more information",

				dc_detail_teaser:
					"Financial welfare application for employees unexpected expense",
				dc_detail_item1_header: "Advance Payment",
				dc_detail_item1_detail:
					"Financial welfare function especially for employees. Which the amount of money will be accumulate everyday that employees come to work*",
				dc_detail_item2_header: "Financial planning",
				dc_detail_item2_detail:
					"Establish financial discipline for the employees with expense management functions and also able to set monthly expense",
				dc_detail_remark_star:
					"*Reserved for employees who sign a contract with DAYCASH only",
				dc_contactus_title: "Contact for more information",
				"contact-form-name-label": "What is your name?",
				"contact-form-company-name-label": "What is company name?",
				"contact-form-number-of-employees-label": "Number of employees?",
				"contact-form-position-label": "Your position in the company",
				"contact-form-email-label":
					"Which email address I can send you a reply?",
				"contact-form-phone-label": "Which number I can call you?",
				"contact-form-subject-label": "What is the subject of your message",
				"contact-form-please-select": "Please select",
				"contact-form-message-label":
					"I'm here, please tell me what is in your mind?",
				"contact-form-header1": "YOUR INFORMATION",
				"contact-form-header2": "YOUR MESSAGE",
				"contact-form-not-sure-yet": "Not sure yet",
				"contact-form-business-owner": "Business Owner",
				"contact-form-human-resources": "Human Resources (HR)",
				"contact-form-investor": "Investor",
				"contact-form-employee": "Employee",
				"contact-form-agent": "Agent",
				"contact-form-request-to-use-daycash": "Request to use DayCash",
				"contact-form-need-info-daycash": "Need more information about DayCash",
				"contact-form-need-help-daycash": "Need help on daily use of DayCash",
				"contact-form-need-suggestion-money-debt":
					"Need suggestion on money/debt management",
				"contact-form-would-like-to-be-partner-agent":
					"Would like to be MoneyTable's Partner or Agent",
				"contact-form-would-like-invest-moneytable":
					"Would like to invest in MoneyTable business",
				"contact-form-name-placeholder": "Fullname",
				"contact-form-submit": "Submit Form",
				"contact-form-phone-placeholder": "Contact Number",

				dc_feature_title: "FEATURE",
				dc_feature_menu1: "Record revenue and expense",
				dc_feature_menu2: "Cost classification",
				dc_feature_menu3: "Present cost management",
				dc_feature_menu4: "Advance payment",

				homepage_hero_title1: "DO YOUR EMPLOYEES",
				homepage_hero_title2: "HAVE CASH FLOW PROBLEMS?",
				homepage_hero_title3:
					"Allow employees to access their earned salaries today with no cost to the company",
				gotoknow_dc: "Register Now",
				homepage_about_title: "complete salary cash flow solutions",
				homepage_about_desc:
					"DAYCASH is an early wage access platform that allows employees to be paid before pay day providing cash flow liquidity.",
				homepage_about_btn1: "Learn more about DAYCASH",
				homepage_about_btn2: "Request for Demo",
				homepage_about_link: "About Moneytable PLC",
				lacking_cashflow1: `Lack of "cash flow" causes financial problems for`,
				lacking_cashflow2: `the employee, the employee's family and business`,
				help_title: "WE ARE HERE TO HELP YOU !",
				help_cashflow_title: "DAYCASH increase personal cash flow to employee",
				help_topic_title1:
					"Employees have early access to their earned salaries for days worked via DayCash App",
				help_topic_title2:
					"Have enough money for living expenses and urgent expenditures.",
				help_topic_title3: "Decrease conflict between work colleagues",
				help_topic_title4:
					"Increase financial freedom with cash flow and credit management",
				help_topic_title5: "No interest, no late fee charges, no hidden fees ",
				help_topic_desc1:
					"Early access to earn salary money before payday can save lives, improve living and avoid unnecessary debt.",
				help_topic_desc1_1: "",
				help_topic_desc2:
					"Stop worrying about money for living expenses, employees come to work, and can get paid on the next working day",
				help_topic_desc3:
					"No more borrowing money from colleagues which can cause workplace problems and issues",
				help_topic_desc4:
					"When employees know how much they can get per day, they can plan and manage their own cash flow better",
				help_topic_desc5:
					"An early wage access service with just an administration fee, employees do not have to worry about interest rates and other charges",
				pic_employee: "employee",
				pic_employer: "employer",

				steps_title: "Just 4 steps for EMPLOYEE to get money",
				steps_title1: "Clock-In at workplace (or in-app)",
				steps_title2: "Check Disbursable money on DAYCASH app",
				steps_title3:
					"Send request to disburse money and wait for HR to approve",
				steps_title4: "Get money via employee payment channel",

				provide_cashflow_title:
					"DAYCASH provide cash flow liquidity for company",
				provide_cashflow_title1:
					"With DayCash, companies now have support in providing financial welfare to employees",
				provide_cashflow_title2:
					"Motivate employees to come to work knowing that they can get paid whenever they want",
				provide_cashflow_title3:
					"Motivate employee comes to work with better efficiency",
				provide_cashflow_title4:
					"Retain and attract employees with financial welfare benefits",
				provide_cashflow_title5: "Increase HR efficiency",
				provide_cashflow_desc1:
					"Using company capital for employee welfare is bad for the business cash flow. But with DayCash support for employee financial welfare, there is no capital cost to the business. The company only has to repay MoneyTable at the end of the month without any additional charges to the company. ",
				provide_cashflow_desc1_1: "",
				provide_cashflow_desc2:
					"Companies can now focus on building their core business and let MoneyTable focus on providing financial welfare to the employees",
				provide_cashflow_desc3:
					"They don't have to borrow money from colleagues, friends, families and loan sharks anymore",
				provide_cashflow_desc4:
					"Companies with financial welfare are 2x as attractive to employees in need. This has helped companies reduce employee turnover by 41%",
				provide_cashflow_desc5:
					"Using MoneyTable has shown to increase HR work efficiency by 20%",
				emp_step_title: "Just 3 steps for EMPLOYER to help employee get money",
				emp_step_title1: "Approve disbursement request",
				emp_step_title2: "Get report of amount to repayment on cut-off date",
				emp_step_title3: "Payback to Moneytable Co., Ltd. before pay date",
				emp_step_sub1: "Daily",
				emp_step_sub2: "Every Cut-off Date",
				emp_step_sub3: "Before Pay Date",
				money_liter_title: "Money literacy blog and training program",
				partner_title1: "With 200 companies using DAYCASH",
				partner_title2:
					"100,000+ employee have better life with healthy cash flow.",
				partner_hero1: "Better benefits,",
				partner_hero2: "Better work efficiency",
				partner_hero3: "Better life",
				partner_hero4: "---- Human Resources Management",
				thx_message: "Thank you for your message",
				thx_reply: "We will be contacting you soon",
				thx_back: "Back to Homepage",
				DC_program_title1: "DAYCASH services and money literacy program",
				DC_program_title2:
					"are limited to employee of MONEYTABLE Co., Ltd. partner company",
				DC_program_desc:
					"You are employee of a company but not sure whether your company is our partner or not? ",
				req_demo: "Request for DAYCASH demo",

				dc_benefit_item2_header: "DAYCASH for Organization",
				dc_benefit_item2_detail1:
					"Manage establish financial discipline and saving money",
				dc_benefit_item2_detail2: "No more providing the reserve fund",
				dc_benefit_item2_detail3:
					"Reduce the burden of financial welfare management",
				dc_benefit_item2_detail4:
					"Build corporate image with care of employees financial problems",
				dc_benefit_item2_detail5: "Employees feel attached to the organization",

				dc_benefit_title: "BENEFIT",
				dc_benefit_teaser:
					"Revenue and expense assistant management and advance payment for employees emergency expense",
				dc_benefit_item1_header: "DAYCASH for Employees",
				dc_benefit_item1_detail1: "Salary management",
				dc_benefit_item1_detail2: "Spending control assistant",
				dc_benefit_item1_detail3: "Advance payment through the application",
				dc_benefit_item1_detail4: "Secure as Banking standards",
				tandc: "Terms & Conditions",
				customers: "Customers",
				aboutmt: "About Moneytable PLC",
				contactMT: "Contact MT",
				saleandsup: "Sales & Support",
				privacypolicy: "Privacy Policy",

				productHeroTitle1: "ACCESS SALARY TODAY",
				productHeroTitle2: "Collect salary by workday, disburse it when needed",
				productHeroDesc1:
					"Daycash is an early wage access platform that allow employees to be paid before payday providing cashflow liquidity for both employees and company.",
				productHeroButton: "Register Now",
				productHeroCaption1: "Collect salary by workday,",
				productHeroCaption2: "disburse it when needed",
				productHeroFeature: "with DAYCASH features",
				productHelpTitle:
					"Let’s SUPPORT EMPLOYEE to have CASH FLOW liquidity and financial credits.",
				productHelpDesc:
					"Employees have cashflow problems potentially causing more problems to themselves and also to the company.",
				productHelpButton: "Help Employee Now",
				productFeature1: "Collect Wage",
				productFeature1_1: "every workday",
				productFeature2: "Request to Disburse",
				productFeature2_1: "whenever needed",
				productFeature3: "Fast Transfer to employee",
				productFeature3_1: "payment channel",
				productFeature4: "Monthly Report",
				productFeature4_1: "for Employer",
				usecaseTitle: "DAYCASH USE CASES",
				usecaseTitle1: "Salary Cash Flow Solutions",
				usecaseDesc1:
					"Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged.",
				usecaseTitle2: "Employee Benefits",
				usecaseDesc2: "Employee Benefits",
				usecaseTitle3: "Avoid Shark Loans",
				usecaseDesc3: "Avoid Shark Loans",
				usecaseTitle4: "Decrease Debt",
				usecaseDesc4: "Decrease Debt",
				usecaseTitle5: "Personal Credits",
				usecaseDesc5: "Personal Credits",
				usecaseTermHeaderTitle:
					"Company and employee in long-term with DAYCASH",
				usecaseTermHeaderDesc:
					"DAYCASH will suggest user to have better discipline on cashflow management based on employee behaviours.",
				usecaseTermItem1: "Less Debt",
				usecaseTermItem1_1: "Less Stress",
				usecaseTermItem2: "Goodbye to",
				usecaseTermItem2_1: "Loanshark",
				usecaseTermItem3: "Better Cashflow",
				usecaseTermItem3_1: "with Money Discipline",
				usecaseTermItem4: "Have credit for",
				usecaseTermItem4_1: "future spending plans",
				benefitTitleNum1: "73% ",
				benefitTitleNum2: "41% ",
				benefitTitle1: "of employee more",
				benefitTitle2: "motivated to come to work.",
				benefitTitle3: "reduction",
				benefitTitle4: "the employee turnover rate.",
				freeTitle1: "DAYCASH",
				freeTitle2: "is FREE for company!",
				freeDesc1: "Ready to support your company and employee",
				freeDesc2:
					"tell us how we could help you and we will get back to you ASAP.",
				customerVoice: "CUSTOMER VOICES",
			},
		},
	},
	fallbackLng: "th",

	// have a common namespace used around the full app
	ns: ["translations"],
	defaultNS: "translations",

	keySeparator: false, // we use content as keys

	interpolation: {
		escapeValue: false, // not needed for react!!
		formatSeparator: ",",
	},

	react: {
		wait: true,
	},
});

export default i18n;



// WEBPACK FOOTER //
// ./src/i18n.js